/* =====================================================================
   Rejuveen / Provitalean Un-Hunger Quiz... vanilla JS port.

   Mounted into #unhunger-quiz-root. Reads window.UNHUNGER_CFG (populated
   by the Liquid section) for image URLs and variant IDs.

   State machine: intro -> 11 questions interleaved with 3 education
   inserts -> analyze -> results (which embeds a 3-step offer flow).

   Checkout flow: direct Shopify cart permalink — /cart/variant:1
   with quiz cart attributes and optional discount code. No fetch/XHR cart
   mutations.

   Tracking calls go to fbq, gtag, and Klaviyo _learnq if present (the
   theme is expected to define those globals before this file loads).
===================================================================== */
(function () {
  'use strict';

  var CFG = window.UNHUNGER_CFG || {};
  var localImgs = CFG.images || {};
  var VARIANTS = CFG.variants || {
    day30: 46401846411426,
    day60: 46401846378658,
    day90: 46401846345890,
  };

  /* ============== IMAGE URL MAP ============== */
  var IMG = {
    /* Local heroes (uploaded to Shopify Files via the section) */
    bottle_solo:                localImgs.bottle_solo                || '',
    ozempic_pen:                localImgs.ozempic_pen                || '',
    weight_ba:                  localImgs.weight_ba                  || '',
    x_mark:                     localImgs.x_mark                     || '',
    offramp_stat:               localImgs.offramp_stat               || '',
    body_comp:                  localImgs.body_comp                  || '',
    rev_christen_p:             localImgs.rev_christen_p             || '',
    rev_theresa_m:              localImgs.rev_theresa_m              || '',
    rev_laurie_d:               localImgs.rev_laurie_d               || '',
    trigger_gut_burnout:        localImgs.trigger_gut_burnout        || '',
    trigger_hunger_switch:      localImgs.trigger_hunger_switch      || '',
    trigger_muscle_starvation:  localImgs.trigger_muscle_starvation  || '',
    trigger_fat_cell_memory:    localImgs.trigger_fat_cell_memory    || '',
    trigger_ampk_dormancy:      localImgs.trigger_ampk_dormancy      || '',
    press_vogue:                localImgs.press_vogue                || '',
    press_womens_health:        localImgs.press_womens_health        || '',
    press_forbes:               localImgs.press_forbes               || '',

    /* Provitalean product imagery (rejuveen.com Shopify CDN) */
    bottle_1:    'https://rejuveen.com/cdn/shop/files/1_botte_provitalean_1_d11ce04e-e5b6-4cce-a02b-22af09c9829a_medium.png?v=1737113601',
    bottle_2:    'https://rejuveen.com/cdn/shop/files/2_bottes_provitalean_1_medium.png?v=1737097606',
    bottle_3:    'https://rejuveen.com/cdn/shop/files/3_bottes_provitalean_1_medium.png?v=1737097574',
    supp_facts:  'https://rejuveen.com/cdn/shop/files/Provitalean_Supplement_Facts_145de51a-1008-4e16-a477-f1e9bf818bbb.png?v=1758873002&width=1080',

    /* Ingredient tiles */
    ig_morosil:    'https://rejuveen.com/cdn/shop/files/ing_1_moro_red.png?v=1736065482&width=480',
    ig_chromium:   'https://rejuveen.com/cdn/shop/files/ing_2_chromium.png?v=1736065529&width=480',
    ig_hibiscus:   'https://rejuveen.com/cdn/shop/files/ing_3_hibiscus.png?v=1736065530&width=480',
    ig_b420:       'https://rejuveen.com/cdn/shop/files/ing_4_b_lactis_B420.png?v=1736065529&width=480',
    ig_lactis:     'https://rejuveen.com/cdn/shop/files/ing_5_b_lactis_L1-23.png?v=1736065529&width=480',
    ig_rhamnosus:  'https://rejuveen.com/cdn/shop/files/ing_6_L_rhamnousus_gg.png?v=1736065529&width=480',

    /* Hero / mechanism imagery */
    ozempic_close: 'https://rejuveen.com/cdn/shop/files/Ozempic_2.jpg?v=1758860667&width=1080',
    safeguard:     'https://rejuveen.com/cdn/shop/files/Safeguard_Formula.jpg?v=1758871373&width=1080',
    vs_chart:      'https://rejuveen.com/cdn/shop/files/Provitalean_vs_Without_Graph_f2e4dead-43c3-4661-a5c1-8627f7346da6.png?v=1763982278&width=1080',

    /* 90-day timeline visuals */
    day_2: 'https://rejuveen.com/cdn/shop/files/First_90_Days_1.jpg?v=1758875768&width=720',
    day_4: 'https://rejuveen.com/cdn/shop/files/First_90_Days_2.jpg?v=1758875806&width=720',
    day_8: 'https://rejuveen.com/cdn/shop/files/First_90_Days_3.jpg?v=1758875875&width=720',

    /* Real-women results photos */
    story_allison:  'https://cdn.shopify.com/s/files/1/0644/2831/0690/files/un-hero_mirror_selfie.png?v=1779462922&width=720',
    story_christen: 'https://rejuveen.com/cdn/shop/files/Christen_Pilkinton.jpg?v=1737084200&width=720',
    story_natty:    'https://rejuveen.com/cdn/shop/files/Success_Stories_3.jpg?v=1758796335&width=720',
    story_jenny:    'https://rejuveen.com/cdn/shop/files/Success_Stories_4.jpg?v=1758796374&width=720',

    /* Healthcare professional headshot */
    pro_kathryn: 'https://rejuveen.com/cdn/shop/files/Healthcare_Professionals_1.jpg?v=1736930378&width=480',

    /* Trust mark */
    money_back: 'https://rejuveen.com/cdn/shop/files/90_day_1024x1024.svg?v=1736241545',
  };

  /* ============== QUIZ DATA ==============
     19 questions in the user-visible flow. The QUESTIONS array also includes
     `time_off` at idx 19 as a branched alternative to `duration` (idx 1),
     shown only when glp1='off'. STEPS below maps step indices to question
     indices and declares per-step skipIf predicates for the branching.

     Note on indexing: order here is referenced by STEPS, not by question
     number shown to the user. Reordering this array WILL break flow. */
  var QUESTIONS = [
    /* 0 · glp1 (kept) */
    {
      id: 'glp1', kind: 'radio', eyebrow: 'Question 01 · Your medication',
      title: 'Which <em>weight-loss<br class="m-br"> medication</em> are you on?',
      sub: 'Each one disrupts gut bacteria the same way... but your dose and class change which strain rebuilds first.',
      imageHero: IMG.ozempic_pen,
      heroTransparent: true,
      options: [
        { v: 'ozempic',    label: 'Ozempic',    tag: 'semaglutide' },
        { v: 'wegovy',     label: 'Wegovy',     tag: 'semaglutide' },
        { v: 'mounjaro',   label: 'Mounjaro',   tag: 'tirzepatide' },
        { v: 'zepbound',   label: 'Zepbound',   tag: 'tirzepatide' },
        { v: 'compounded', label: 'Compounded sema or tirz', tag: 'telehealth / pharmacy' },
        { v: 'off',        label: "I've already come off",   tag: 'rebound window open' },
      ],
    },
    /* 1 · duration (kept · branched: skipped when glp1='off') */
    {
      id: 'duration', kind: 'radio', eyebrow: 'Question 02 · Timeline',
      title: 'How long have you<br class="m-br"> been <em>on the shot?</em>',
      sub: 'Akkermansia muciniphila depletion compounds over time. Where you are on the curve changes the protocol.',
      options: [
        { v: 'lt3',   label: 'Less than 3 months', tag: 'gut bacteria still mostly intact' },
        { v: '3to6',  label: '3–6 months',         tag: 'first wave of burnout' },
        { v: '6to12', label: '6–12 months',        tag: 'satiety strains depleted' },
        { v: 'gt12',  label: 'Over a year',        tag: 'chronic gut bacterial burnout' },
        { v: 'past',  label: 'Already stopped',    tag: 'in the rebound window' },
      ],
    },
    /* 2 · gained_year (NEW yesno · skipped when glp1!=='off' && stop_plan='staying') */
    {
      id: 'gained_year', kind: 'yesno', eyebrow: 'Question 03 · Recent direction',
      title: 'Have you <em>gained weight</em><br class="m-br"> in the last year?',
      sub: 'If the scale has crept back even a little, the satiety strains are already depleting. We adjust the rebuild dose accordingly.',
      options: [
        { v: 'yes', label: 'Yes', tag: 'rebound signal active' },
        { v: 'no',  label: 'No',  tag: 'holding ground for now' },
      ],
    },
    /* 3 · stop_plan (kept · skipped when glp1='off') */
    {
      id: 'stop_plan', kind: 'radio', eyebrow: 'Question 04 · Off-ramp',
      title: "What's your <em>off-ramp plan?</em>",
      imageHero: IMG.offramp_stat,
      heroBare: true,
      options: [
        { v: 'taper-now',   label: "I'm tapering now",                       tag: 'rebound risk window opening' },
        { v: 'soon',        label: 'Planning to stop in the next 90 days',   tag: 'pre-stop prep window · help reduce dip risk' },
        { v: 'staying',     label: "I'm staying on indefinitely",            tag: 'long-term gut support' },
        { v: 'undecided',   label: "Not sure yet... it depends",             tag: 'optionality matters' },
        { v: 'already-off', label: 'Already off and rebounding',             tag: 'urgent rebuild' },
      ],
    },
    /* 4 · body_areas (NEW chips · replaces single-select belly) */
    {
      id: 'body_areas', kind: 'chips', eyebrow: 'Question 05 · Where it shows up',
      title: 'Which areas of your body feel <em>most problematic?</em>',
      sub: 'Select all that apply. The pattern tells us whether to weight your protocol toward AMPK reactivation, lean-mass support, or full-body recomposition.',
      options: [
        { v: 'stomach',    label: 'Stomach' },
        { v: 'hipsthighs', label: 'Hips and thighs' },
        { v: 'arms',       label: 'Arms' },
        { v: 'face',       label: 'Face' },
        { v: 'whole',      label: 'Whole body' },
        { v: 'nothing',    label: 'Prefer not to answer' },
      ],
    },
    /* 5 · muscle (kept · new body-composition hero) */
    {
      id: 'muscle', kind: 'radio', eyebrow: 'Question 06 · Body composition',
      title: 'Has your body started<br class="m-br"> looking <em>deflated?</em>',
      sub: 'Up to 1 lb of lean mass per 2 lbs of fat... the Oxford BMJ paper called it sarcopenia risk. The mirror calls it something worse.',
      // imageHero: IMG.body_comp,
      heroBare: true,
      options: [
        { v: 'strong',   label: 'No, I look strong and toned',              tag: 'lean mass holding' },
        { v: 'looser',   label: 'Arms and inner thighs feel looser',        tag: 'early lean-mass loss' },
        { v: 'deflated', label: 'Hollow face, deflated arms, soft glutes',  tag: 'classic shot-induced muscle wasting' },
        { v: 'elephant', label: '"Elephant butt" / saggy skin everywhere',  tag: 'muscle starvation syndrome' },
        { v: 'weaker',   label: "I'm visibly smaller AND weaker",           tag: 'urgent muscle rebuild' },
      ],
    },
    /* 6 · food_noise (kept) */
    {
      id: 'food_noise', kind: 'severity', eyebrow: 'Question 07 · Food noise',
      title: 'How loud is your<br class="m-br"> <em>food noise</em> right now?',
      sub: 'The shot quieted it. As gut bacteria deplete, the volume climbs back up... usually first in the late afternoon.',
      scale: [
        { v: 1, label: 'Silent' },
        { v: 2, label: 'Whispers' },
        { v: 3, label: 'Coming back' },
        { v: 4, label: 'Loud again' },
        { v: 5, label: 'Screaming' },
      ],
    },
    /* 7 · gi_symptoms (NEW chips · replaces single-select digestion) */
    {
      id: 'gi_symptoms', kind: 'chips', eyebrow: 'Question 08 · Gut signals',
      title: 'Do you tend to experience any of the <em>following?</em>',
      sub: 'Select all that apply. Each one is a real-time signal of microbiome disruption from slowed gastric emptying.',
      options: [
        { v: 'constipation', label: 'Constipation' },
        { v: 'nausea',       label: 'Nausea / sulfur burps' },
        { v: 'bloating',     label: 'Bloating / gas' },
        { v: 'fog',          label: 'Low energy / fog' },
        { v: 'nothing',      label: 'None of these' },
      ],
    },
    /* 8 · meds_history (NEW radio) */
    {
      id: 'meds_history', kind: 'radio', eyebrow: 'Question 09 · Medication history',
      title: 'Have you taken <em>antibiotics or<br class="m-br"> acid-suppressing meds</em><br class="d-br"> in the last 12 months?',
      sub: 'Both wipe out the same satiety strains the shot already depletes. Stacking them speeds up gut bacterial burnout.',
      options: [
        { v: 'none',     label: 'None',                              tag: 'gut history clean' },
        { v: 'short',    label: 'Short course (less than 14 days)',  tag: 'minor disruption' },
        { v: 'multiple', label: 'Multiple courses',                  tag: 'compounded depletion' },
        { v: 'ppi',      label: 'I take PPIs / antacids',            tag: 'chronic acid suppression · high disruption' },
      ],
    },
    /* 9 · veggies (NEW radio) */
    {
      id: 'veggies', kind: 'radio', eyebrow: 'Question 10 · Daily fuel',
      title: 'How often do you <em>eat<br class="m-br"> vegetables?</em>',
      sub: 'Raw or cooked, prepared in a healthy way. Fiber is what feeds the keystone bacteria your shot has been starving.',
      options: [
        { v: 'none',  label: "I don't really eat veggies",      tag: 'no fiber substrate' },
        { v: 'some',  label: 'I eat veggies from time to time', tag: 'sparse fiber' },
        { v: 'daily', label: 'I eat veggies every day',         tag: 'baseline fiber intake' },
        { v: 'most',  label: 'I eat mostly veggies',            tag: 'strong fiber base' },
      ],
    },
    /* 10 · age (kept · pills) */
    {
      id: 'age', kind: 'pills', eyebrow: 'Question 11 · Life stage',
      title: "What's your <em>age range?</em>",
      sub: 'Estrogen, sleep, and lean-mass turnover all shift with age. We dose accordingly.',
      options: [
        { v: '25-34', big: '25–34', small: 'pre-peri' },
        { v: '35-44', big: '35–44', small: 'perimeno' },
        { v: '45-54', big: '45–54', small: 'meno' },
        { v: '55-64', big: '55–64', small: 'post-meno' },
        { v: '65+',   big: '65+',   small: 'sarcopenia risk' },
      ],
    },
    /* 11 · lost (kept) */
    {
      id: 'lost', kind: 'radio', eyebrow: 'Question 12 · Your progress',
      title: 'How much weight have you<br class="m-br"> <em>lost so far?</em>',
      sub: 'More weight lost = more lean mass and microbiome disruption. We adjust the satiety-strain dose to match.',
      // imageHero: IMG.weight_ba,
      heroBare: true,
      options: [
        { v: '<15',   label: 'Under 15 lbs',    tag: 'early loss · help reduce dip risk' },
        { v: '15-30', label: '15–30 lbs',       tag: 'moderate microbiome disruption' },
        { v: '30-50', label: '30–50 lbs',       tag: 'significant lean-mass risk' },
        { v: '50+',   label: 'Over 50 lbs',     tag: 'maximum gut bacterial burnout' },
      ],
    },
    /* 12 · current_weight (NEW number) */
    {
      id: 'current_weight', kind: 'number', eyebrow: 'Question 13 · Where you are now',
      title: "What's your <em>current weight?</em>",
      sub: 'Used only to personalize your projection. Your number stays on this device.',
      placeholder: 'Current weight',
      unit: 'lbs',
      min: 80, max: 500,
    },
    /* 13 · exercise (NEW radio) */
    {
      id: 'exercise', kind: 'radio', eyebrow: 'Question 14 · Movement',
      title: 'How often do you <em>exercise?</em>',
      sub: 'Anything from a brisk 30-minute walk to an intense gym session. Movement is what tells the body to hold onto lean mass during the loss.',
      options: [
        { v: 'none', label: 'Little / none',       tag: 'lean-mass risk elevated' },
        { v: 'low',  label: '1 to 2 days a week',  tag: 'baseline movement' },
        { v: 'mid',  label: '3 to 4 days a week',  tag: 'lean-mass holding' },
        { v: 'high', label: '5+ days a week',      tag: 'strong muscle support' },
      ],
    },
    /* 14 · goal_weight (NEW number · drives MidBreak + Results forecast charts) */
    {
      id: 'goal_weight', kind: 'number', eyebrow: 'Question 15 · Your target',
      title: "What's your <em>goal weight</em>...<br class=\"d-br\"> or the weight you want<br class=\"d-br\"> to maintain long term?",
      sub: 'This is the number we lock your protocol to. Every section of your results page connects back to this answer.',
      placeholder: 'Goal weight',
      unit: 'lbs',
      min: 80, max: 500,
    },
    /* 15 · regain (kept · moved to after MidBreak) */
    {
      id: 'regain', kind: 'radio', eyebrow: 'Question 18 · Regain history',
      title: 'Have you regained<br class="m-br"> weight <em>before?</em>',
      sub: 'Hinte 2024 (Nature) showed fat cells keep an epigenetic memory of obesity. The more cycles, the louder the memory.',
      options: [
        { v: 'first', label: 'No, this is my first real weight loss',  tag: 'fresh slate' },
        { v: 'some',  label: 'Yes, but only some came back',           tag: 'partial regain history' },
        { v: 'all',   label: 'Yes, all of it eventually came back',    tag: 'full-cycle regain' },
        { v: 'worse', label: 'All of it... and then some, every time', tag: 'fat cell memory locked in' },
      ],
    },
    /* 16 · goal (kept · moved to after MidBreak) */
    {
      id: 'goal', kind: 'radio', eyebrow: 'Question 19 · Your #1 goal',
      title: 'What matters <em>most</em><br class="m-br"> to you right now?',
      sub: "We'll personalize your 90-day Provitalean protocol around this single answer.",
      options: [
        { v: 'no_rebound',  label: 'Keep my results when I stop the shot',       tag: 'rebound resistance track' },
        { v: 'quiet_noise', label: "Silence the food noise that's coming back",  tag: 'satiety-strain track' },
        { v: 'rebuild',     label: 'Stop looking deflated... rebuild my shape',  tag: 'muscle preservation track' },
        { v: 'belly',       label: 'Finally lose this stubborn abdominal fat',   tag: 'AMPK / Morosil track' },
      ],
    },
    /* 17 · commit_start (NEW radio · micro-commitment after MidBreak) */
    {
      id: 'commit_start', kind: 'radio', eyebrow: 'Question 16 · Readiness',
      title: 'When are you ready to <em>start<br class="m-br"> rebuilding?</em>',
      sub: 'Your gut bacteria start regenerating from day one of the protocol. The sooner you begin, the further ahead of the rebound window you stay.',
      options: [
        { v: 'today',      label: "Today, I'm ready to take action",  tag: 'highest-intent window' },
        { v: 'this_week',  label: 'This week',                        tag: 'short runway' },
        { v: 'this_month', label: 'Within the next month',            tag: 'planning ahead' },
        { v: 'exploring',  label: 'Just exploring for now',           tag: 'gathering information' },
      ],
    },
    /* 18 · commit_90day (NEW radio · 90-day commitment after MidBreak) */
    {
      id: 'commit_90day', kind: 'radio', eyebrow: 'Question 17 · 90-day commitment',
      title: 'Will you commit to the <em>full<br class="m-br"> 90 days?</em>',
      sub: 'The Lancet eClinicalMedicine data on satiety-strain recolonization shows 90 days is the minimum window for the gut to take the off-switch back from the shot. Anything shorter is a half-rebuild.',
      options: [
        { v: 'yes',      label: "Yes, I'll commit to the full 90 days", tag: 'protocol-ready' },
        { v: 'probably', label: 'Probably... if I see early signs',     tag: 'tentative · needs early wins' },
        { v: 'unsure',   label: "I'm not sure I can stick to 90 days",  tag: 'consistency risk flagged' },
      ],
    },
    /* 19 · time_off (NEW radio · branched alternative to duration; shown
       only when glp1='off'. Normalized into `duration` downstream so
       scoring, profile, Klaviyo, and checkout attributes keep working;
       also persisted as its own attribute for segmentation). */
    {
      id: 'time_off', kind: 'radio', eyebrow: 'Question 02 · Time since stopping',
      title: 'How long ago did you<br class="m-br"> <em>come off the shot?</em>',
      sub: 'The rebound window opens fast. Knowing where you are on it tells us how aggressively to rebuild the satiety strains.',
      options: [
        { v: 'lt1',    label: 'Less than 1 month ago',  tag: 'fresh stop · early rebound risk' },
        { v: '1to3',   label: '1–3 months ago',         tag: 'peak rebound window' },
        { v: '3to6',   label: '3–6 months ago',         tag: 'satiety strains still depleted' },
        { v: '6to12',  label: '6–12 months ago',        tag: 'rebuild needed before more regain' },
        { v: 'gt12',   label: 'Over a year ago',        tag: 'chronic rebound territory' },
      ],
    },
  ];

  /* Maps time_off bucket → duration bucket. Used at answer time to keep the
     downstream Akkermansia/satiety scoring, profile selection, Diagnostic
     Snapshot, Klaviyo identify, and Shopify cart attributes all working
     without per-branch forks. time_off is still persisted on its own. */
  var TIME_OFF_TO_DURATION = {
    'lt1':   'lt3',
    '1to3':  'lt3',
    '3to6':  '3to6',
    '6to12': 'past',
    'gt12':  'past',
  };

  /* ============== EDUCATION INSERTS ============== */
  var EDUCATION = {
    stat1: {
      badge: 'RESEARCH INSERT',
      label: 'The rebound is the<br class="m-br"> rule, not the exception.',
      num: 75.3, suffix: '%',
      cap: 'of weight lost on the shot is plateaued back beyond 52 weeks (Lancet eClinicalMedicine, March 2026).',
      source: 'Confirmed by the Oxford BMJ 9,341-woman analysis (Jan 2026): regain after the shot runs ~4× faster than after a diet program. The shot quiets your appetite. It does not retrain the gut bacteria that decide whether the cravings come back.',
      image: IMG.vs_chart,
    },
    stat2: {
      badge: 'THE REBOUND CASCADE',
      label: "Good news: GLP-1 rebound almost always traces back to your #1 rebound trigger... and that's different for every body.",
      sub: "Your next few answers pinpoint which one is hitting you hardest right now.",
      triggers: [],
      iconRow: [
        { name: 'Gut Bacterial Burnout',        art: IMG.trigger_gut_burnout },
        { name: 'Lean Muscle Starvation',        art: IMG.trigger_muscle_starvation },
        { name: 'Overactive Hunger Switch',      art: IMG.trigger_hunger_switch },
        { name: 'Dormant Fat-Burning Enzymes',   art: IMG.trigger_ampk_dormancy },
      ],
    },
    stat3: {
      badge: 'CLINICAL EVIDENCE',
      num: 4.5, suffix: '%',
      cap: 'reduction in body fat mass with B. lactis B420™ in a 6-month, double-blind, placebo-controlled trial.',
      source: 'Stenman et al., EBioMedicine 2016, n=225 overweight adults. Morosil® red orange separately cut waist circumference by 2.5cm in 12 weeks (Cardile et al., 2015).',
      extra: '+ 571% DV chromium · clinically studied appetite control',
      image: IMG.ig_b420,
    },
  };

  /* MidBreak screen content. The personalized forecast chart is computed in
     viewMidBreak from current_weight + goal_weight; this block holds only
     the static copy and bottle imagery. */
  var MIDBREAK = {
    badge: "WE'VE GOT YOU",
    title: "That's <em>definitely</em> something we can help with.",
    image: IMG.bottle_solo,
    body: [
      'With Provitalean, you get a complete formula designed to help your body reach and hold your goal weight by:',
      [
        'Rebuilding the gut bacteria the weekly injection depletes... so your metabolism works the way it should again.',
        'Quieting the food noise and calming cravings without restriction.',
        'Supporting steady, natural fat-burning. Even after stopping the shot.',
      ],
      'Thousands of women are already using Provitalean to lock in their results and feel in control of their appetite, their metabolism, and their body again.',
      "Let's finish your quiz and get your personalized results.",
    ],
    cta: 'Continue',
  };

  /* ============== PACKAGES ============== */
  var PACKAGES = [
    { k: '90', months: '90-Day Supply', bottles: 3, per: '$1.63', total: 147, strike: 237, save: 90, badge: 'BEST VALUE',
      bundle: IMG.bottle_3, variantId: VARIANTS.day90,
      url: '/cart/' + VARIANTS.day90 + ':1' },
    { k: '60', months: '60-Day Supply', bottles: 2, per: '$1.80', total: 108, strike: 158, save: 50, badge: 'POPULAR',
      bundle: IMG.bottle_2, variantId: VARIANTS.day60,
      url: '/cart/' + VARIANTS.day60 + ':1' },
    { k: '30', months: '30-Day Supply', bottles: 1, per: '$1.97', total: 59,  strike: 79,  save: 20, badge: null,
      bundle: IMG.bottle_1, variantId: VARIANTS.day30,
      url: '/cart/' + VARIANTS.day30 + ':1' },
  ];

  /* ============== STEPS ==============
     Each step references a QUESTIONS index by `idx`. skipIf predicates run
     against the current answers map and skip the step when truthy. Q1=off
     routes the user down the "already off the shot" branch (time_off Q2b
     instead of duration Q2a; stop_plan and gained_year skipped).

     edu1/edu3 from the prior build are removed: the 75.3% stat now reveals
     on the MidBreak page after Q15 where we have current+goal weight in
     hand for the personalized forecast chart. midbreak/edu2 visuals are
     placeholders in Phase 1; Phase 2 ships the real content. */
  var STEPS = [
    { type: 'intro' },                                                                              // intro captures glp1 inline (Q1)
    { type: 'q', idx: 1,  skipIf: function (a) { return a.glp1 === 'off'; } },                      // duration (Q2a)
    { type: 'q', idx: 19, skipIf: function (a) { return a.glp1 !== 'off'; } },                      // time_off  (Q2b)
    { type: 'q', idx: 3,  skipIf: function (a) { return a.glp1 === 'off'; } },                      // stop_plan
    { type: 'q', idx: 2,  skipIf: function (a) { return a.glp1 !== 'off' && a.stop_plan === 'staying'; } },  // gained_year
    { type: 'q', idx: 4 },                                                                          // body_areas
    { type: 'q', idx: 5 },                                                                          // muscle
    { type: 'q', idx: 6 },                                                                          // food_noise
    { type: 'q', idx: 7 },                                                                          // gi_symptoms
    { type: 'edu2' },                                                                               // Edu interstitial (Phase 2 rewrites content)
    { type: 'q', idx: 8 },                                                                          // meds_history
    { type: 'q', idx: 9 },                                                                          // veggies
    { type: 'q', idx: 10 },                                                                         // age
    { type: 'q', idx: 11 },                                                                         // lost
    { type: 'q', idx: 12 },                                                                         // current_weight
    { type: 'q', idx: 13 },                                                                         // exercise
    { type: 'q', idx: 14 },                                                                         // goal_weight
    { type: 'midbreak' },                                                                           // "We've Got You" (Phase 2 ships the chart)
    { type: 'q', idx: 17 },                                                                         // commit_start
    { type: 'q', idx: 18 },                                                                         // commit_90day
    { type: 'q', idx: 15 },                                                                         // regain
    { type: 'q', idx: 16 },                                                                         // goal
    { type: 'analyze' },
    { type: 'results' },
  ];

  /* skipIf-aware navigation helpers. Used by render() and the onClick action
     handlers. State is the source of truth — these always read state.answers
     so callers that mutate answers before navigating get the fresh branch. */
  function isStepVisible(st) {
    return !st || !st.skipIf || !st.skipIf(state.answers);
  }
  function gotoNext() {
    var n = state.step + 1;
    while (n < STEPS.length && !isStepVisible(STEPS[n])) n++;
    state.step = Math.min(n, STEPS.length - 1);
  }
  function gotoBack() {
    var n = state.step - 1;
    while (n > 0 && !isStepVisible(STEPS[n])) n--;
    state.step = Math.max(n, 0);
  }
  /* Snap forward if the persisted step (or a step landed-on after a back
     navigation followed by an answer change) is no longer visible. */
  function ensureStepVisible() {
    if (!isStepVisible(STEPS[state.step])) gotoNext();
  }

  /* setAnswer is the single mutation point for state.answers. It applies:
     - glp1='off' mirror: duration='past', stop_plan='already-off' so the
       scoring/profile/Klaviyo/checkout codepath that reads `duration` and
       `stop_plan` keeps working without per-branch forks.
     - glp1 off→on switch: clear the mirrors (and any time_off) so an on-shot
       user isn't pre-seeded with the previous off-branch answers.
     - time_off → duration normalization (TIME_OFF_TO_DURATION map).
     - stop_plan='staying' invalidates gained_year (which is skipIf'd in that
       branch). Cleared so it doesn't keep biasing downstream consumers. */
  function setAnswer(qid, value) {
    if (qid === 'glp1') {
      if (value === 'off') {
        state.answers.duration = 'past';
        state.answers.stop_plan = 'already-off';
      } else {
        if (state.answers.time_off || state.answers.duration === 'past') {
          delete state.answers.duration;
        }
        if (state.answers.stop_plan === 'already-off') delete state.answers.stop_plan;
        delete state.answers.time_off;
      }
    }
    state.answers[qid] = value;
    if (qid === 'time_off' && TIME_OFF_TO_DURATION[value]) {
      state.answers.duration = TIME_OFF_TO_DURATION[value];
    }
    if (qid === 'stop_plan' && value === 'staying' &&
        state.answers.glp1 !== 'off' && state.answers.gained_year !== undefined) {
      delete state.answers.gained_year;
    }
    persistState();
  }

  /* Builds the snake_case attribute payload shared by Klaviyo identify and
     the Shopify cart permalink. Multi-select chips are joined to a comma
     string so they round-trip cleanly through ?attributes[k]=v URL encoding
     and stay readable in the Shopify admin order view. extras is shallow-
     merged last so callers can override or add identity fields. */
  function buildQuizPayload(extras) {
    var a = state.answers;
    var p = {
      glp1_medication: a.glp1 || '',
      glp1_duration:   a.duration || '',
      time_off:        a.time_off || '',
      gained_year:     a.gained_year || '',
      stop_plan:       a.stop_plan || '',
      body_areas:      Array.isArray(a.body_areas) ? a.body_areas.join(',') : '',
      muscle_loss:     a.muscle || '',
      food_noise:      a.food_noise != null ? String(a.food_noise) : '',
      gi_symptoms:     Array.isArray(a.gi_symptoms) ? a.gi_symptoms.join(',') : '',
      meds_history:    a.meds_history || '',
      veggies:         a.veggies || '',
      age:             a.age || '',
      lost:            a.lost || '',
      current_weight:  a.current_weight != null ? String(a.current_weight) : '',
      exercise:        a.exercise || '',
      goal_weight:     a.goal_weight != null ? String(a.goal_weight) : '',
      regain_history:  a.regain || '',
      goal:            a.goal || '',
      commit_start:    a.commit_start || '',
      commit_90day:    a.commit_90day || '',
    };
    if (extras) {
      Object.keys(extras).forEach(function (k) { p[k] = extras[k]; });
    }
    return p;
  }

  /* ============== STORAGE ============== */
  var safeLS = (function () {
    try {
      var t = '__unlt__';
      localStorage.setItem(t, '1');
      localStorage.removeItem(t);
      return {
        get: function (k) { return localStorage.getItem(k); },
        set: function (k, v) { localStorage.setItem(k, v); },
      };
    } catch (e) {
      var mem = {};
      return {
        get: function (k) { return Object.prototype.hasOwnProperty.call(mem, k) ? mem[k] : null; },
        set: function (k, v) { mem[k] = String(v); },
      };
    }
  })();

  var state = {
    step: 0,
    answers: {},
    plan: '90',
    offerStep: 1,
    resultStage: 1,
  };

  /* Stage constants for the multi-step results page. */
  var RESULT_STAGE_COUNT  = 7;
  var RESULT_STEP_COUNT   = 6;  /* 6 content steps; stage 7 (Checkout) has no bar */
  /* 1-to-1: each stage maps to its own bar step. Stage 7 = 7 (no bar rendered). */
  var STAGE_TO_STEP       = [1, 2, 3, 4, 5, 6, 7];
  var RESULT_STAGE_LABELS = ['Summary', 'Diagnosis', 'Protocol', 'Ingredients', 'Reviews', 'Plan', 'Checkout'];

  /* Storage keys are versioned (un_v2_*) so stale state from the prior
     11-question flow doesn't deserialize into the new 19-question branched
     flow with mismatched step indices and missing required answers. */
  (function loadState() {
    var s = parseInt(safeLS.get('un_v2_step') || '0', 10);
    if (isNaN(s) || s < 0) s = 0;
    if (s >= STEPS.length) s = STEPS.length - 1;
    state.step = s;
    try {
      state.answers = JSON.parse(safeLS.get('un_v2_answers') || '{}') || {};
    } catch (e) { state.answers = {}; }
    var rs = parseInt(safeLS.get('un_v2_result_stage') || '1', 10);
    state.resultStage = (isNaN(rs) || rs < 1 || rs > RESULT_STAGE_COUNT) ? 1 : rs;
  })();

  function persistState() {
    safeLS.set('un_v2_step', String(state.step));
    safeLS.set('un_v2_answers', JSON.stringify(state.answers));
    safeLS.set('un_v2_result_stage', String(state.resultStage));
  }

  /* ============== TRACKING ============== */
  var STANDARD_PIXEL_EVENTS = { Lead: 1, AddToCart: 1, InitiateCheckout: 1 };
  var GA4_EVENT_MAP = {
    QuizStart: 'quiz_start',
    QuizComplete: 'quiz_complete',
    Lead: 'generate_lead',
    AddToCart: 'add_to_cart',
    InitiateCheckout: 'begin_checkout',
  };

  function track(name, params) {
    params = params || {};
    try {
      if (typeof window.fbq === 'function') {
        if (STANDARD_PIXEL_EVENTS[name]) window.fbq('track', name, params);
        else window.fbq('trackCustom', name, params);
      }
      if (typeof window.gtag === 'function') {
        window.gtag('event', GA4_EVENT_MAP[name] || name, params);
      }
    } catch (err) { /* swallow */ }
  }

  function klaviyoIdentify(props) {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', props]);
    } catch (err) { /* swallow */ }
  }

  var LEAD_FIRED_KEY = 'un_lead_fired';
  function hasLeadFired() {
    try { return sessionStorage.getItem(LEAD_FIRED_KEY) === '1'; }
    catch (e) { return false; }
  }
  function markLeadFired() {
    try { sessionStorage.setItem(LEAD_FIRED_KEY, '1'); }
    catch (e) { /* swallow */ }
  }

  /* ============== HELPERS ============== */
  function esc(str) {
    if (str == null) return '';
    return String(str).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function imgTag(src, alt, attrs) {
    if (!src) return '';
    attrs = attrs || {};
    var attrStr = '';
    for (var k in attrs) {
      if (attrs[k] != null && k !== 'loading') attrStr += ' ' + k + '="' + esc(attrs[k]) + '"';
    }
    return '<img src="' + esc(src) + '" alt="' + esc(alt || '') + '" loading="' + (attrs.loading || 'lazy') + '"' + attrStr + '>';
  }

  /* Render **bold** markers as <strong>; everything else passes through. */
  function renderRich(text) {
    if (!text) return '';
    var out = '';
    var parts = String(text).split(/(\*\*[^*]+\*\*)/g);
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      if (part.length > 4 && part.indexOf('**') === 0 && part.lastIndexOf('**') === part.length - 2) {
        out += '<strong>' + esc(part.slice(2, -2)) + '</strong>';
      } else {
        out += esc(part);
      }
    }
    return out;
  }

  function getRoot() {
    return document.getElementById('unhunger-quiz-root');
  }

  function frameIsScrollable(frame) {
    if (!frame) return false;
    return frame.scrollHeight > frame.clientHeight + 1;
  }

  function scrollToTop() {
    var frame = document.querySelector('#unhunger-quiz-root .phone-frame');
    var body = document.querySelector('#unhunger-quiz-root .quiz-body');
    if (frame) frame.scrollTop = 0;
    if (body) body.scrollTop = 0;
    var root = document.getElementById('unhunger-quiz-root');
    if (root && typeof root.scrollIntoView === 'function') {
      root.scrollIntoView({ block: 'start' });
    } else {
      window.scrollTo(0, 0);
    }
  }

  function scrollToId(id, offset) {
    var elTarget = document.getElementById(id);
    if (!elTarget) return;
    if (offset == null) offset = id === 'offer-anchor' ? 12 : 60;

    var frame = document.querySelector('#unhunger-quiz-root .phone-frame');
    if (frameIsScrollable(frame)) {
      var target = elTarget.getBoundingClientRect().top - frame.getBoundingClientRect().top + frame.scrollTop - offset;
      frame.scrollTo({ top: target, behavior: 'smooth' });
      return;
    }

    var rect = elTarget.getBoundingClientRect();
    var pageY = rect.top + (window.pageYOffset || document.documentElement.scrollTop || 0) - offset;
    if (typeof window.scrollTo === 'function') {
      try { window.scrollTo({ top: pageY, behavior: 'smooth' }); }
      catch (err) { window.scrollTo(0, pageY); }
    }
  }

  function updateOfferStep() {
    var content = document.querySelector('#unhunger-quiz-root .offer-step-content');
    if (!content) {
      render();
      setTimeout(function () { scrollToId('offer-anchor'); }, 50);
      return;
    }
    content.innerHTML = viewOfferStep(state.offerStep);

    var stepNodes = document.querySelectorAll('#unhunger-quiz-root .offer-progress .op-step');
    for (var i = 0; i < stepNodes.length; i++) {
      var n = i + 1;
      var node = stepNodes[i];
      node.classList.toggle('active', state.offerStep >= n);
      node.classList.toggle('current', state.offerStep === n);
      var num = node.querySelector('.op-num');
      if (num) num.textContent = state.offerStep > n ? '✓' : String(n);
    }

    persistState();
    scrollToId('offer-anchor');
  }

  /* ============== INTRO VIEW ============== */
  /* Intro screen · captures Q1 (glp1) inline so the user starts the quiz
     by tapping a medication option. The standalone glp1 step is gone from
     STEPS; picking a chip fires `answer-intro-glp1` which sets the answer
     (with the off → past mirror applied via setAnswer) and gotoNexts into
     the branched flow. The sticky CTA at the bottom only appears once the
     user scrolls past the hero — it scrolls back up to the option list. */
  function viewIntro() {
    var q1 = QUESTIONS[0];
    var totalQs = visibleQuestionTotal();
    var optionsHtml = q1.options.map(function (o, i) {
      return '<button class="iq1-option" data-action="answer-intro-glp1" data-value="' + esc(o.v) + '" style="animation-delay:' + (i * 50) + 'ms">' +
        '<span class="iq1-opt-label">' +
          '<span>' + esc(o.label) + '</span>' +
          (o.tag ? '<span class="iq1-opt-tag">' + esc(o.tag) + '</span>' : '') +
        '</span>' +
        '<span class="iq1-opt-arrow">→</span>' +
      '</button>';
    }).join('');

    return [
      '<div class="quiz-shell intro-shell intro-merged">',
      '  <div class="brand-ribbon">',
      localImgs.logo ? imgTag(localImgs.logo, 'Rejuveen') : '<span style="color:#fff;font-family:var(--serif);font-style:italic;font-size:18px">rejuveen</span>',
      '  </div>',
      '  <div class="quiz-body">',
      '    <div class="hero">',
      '      <div style="position:relative;z-index:2">',
      '        <div class="hero-pre"><span class="dot">●</span> FOR WOMEN ON OZEMPIC · WEGOVY · MOUNJARO · ZEPBOUND</div>',
      '        <p class="intro-subhead">Lock in the loss. <em>Without staying on the shot forever.</em>',
      '          <span class="intro-subhead-aux"> Get a free personalized plan to help avoid the rebound most women experience on the weekly injection.</span>',
      '        </p>',
      '        <div class="intro-q1-card">',
      '          <div class="iq1-meta">',
      '            <span class="iq1-label">QUESTION 01 OF ' + totalQs + ' · YOUR MEDICATION</span>',
      '            <span class="iq1-time">~90 SECONDS</span>',
      '          </div>',
      '          <div class="iq1-bar"><div class="iq1-fill" style="width:' + ((1 / totalQs) * 100) + '%"></div></div>',
      '          <h1 class="iq1-title">' + q1.title + '</h1>',
      q1.sub ? '<p class="iq1-sub">' + esc(q1.sub) + '</p>' : '',
      '          <div class="iq1-options">' + optionsHtml + '</div>',
      '          <div class="uc-trust">Private · No email to see your results · Health-Expert Recommended (RNs &amp; integrative medicine MDs)</div>',
      '        </div>',
      '        <div class="hero-poster hero-poster-v2">',
      imgTag(IMG.story_allison, 'Real woman after using Provitalean alongside the weekly injection', { loading: 'eager', fetchpriority: 'high', decoding: 'sync' }),
      '        </div>',
      '        <div class="cred-strip">',
      '          <div class="cred-col"><div class="cred-num">75.3%</div><div class="cred-lbl">Of the loss plateaus back past 52 weeks</div><div class="cred-src">Lancet eClinicalMedicine, Mar 2026</div></div>',
      '          <div class="cred-col"><div class="cred-num">1 in 4</div><div class="cred-lbl">Women still on the shot a year out</div><div class="cred-src">NPR, April 2026</div></div>',
      '          <div class="cred-col"><div class="cred-num">4×</div><div class="cred-lbl">Faster regain in women who stop the shot</div><div class="cred-src">Post-cessation regain data, 2024–25</div></div>',
      '        </div>',
      '      </div>',
      '    </div>',
      '  </div>',
      '  <button class="sticky-cta" data-action="scroll-to-intro-options" hidden>PICK YOUR MEDICATION <span class="arrow">↑</span></button>',
      '</div>',
    ].join('');
  }

  /* ============== PROGRESS ==============
     Progress bar reflects the user's position across all progress-showing
     steps (questions + insight screens), so it advances monotonically even
     when an "Insight"/"Breakdown" screen sits between questions. */
  function isProgressStep(step) {
    if (!step) return false;
    return step.type === 'q' ||
           step.type === 'edu1' || step.type === 'edu2' || step.type === 'edu3' ||
           step.type === 'midbreak';
  }
  /* Branch-aware progress: skipIf'd steps (off-branch time_off when on-shot,
     gained_year when staying indefinitely, etc.) are excluded so the bar and
     counter reflect the user's actual path, not the union of branches. */
  function computeProgressPercent() {
    var total = 0;
    var done = 0;
    for (var i = 0; i < STEPS.length; i++) {
      if (!isProgressStep(STEPS[i])) continue;
      if (!isStepVisible(STEPS[i])) continue;
      total++;
      if (i <= state.step) done++;
    }
    if (total === 0) return 0;
    return (done / total) * 100;
  }
  /* Visible-question count. Intro counts as a question (it captures glp1
     inline as Q1), q-type steps count, edu/midbreak/analyze/results don't.
     visibleQuestionPos returns the 1-indexed position of the current step
     within that visible list — viewQuestion uses it for the "N / TOTAL"
     counter so it always agrees with the intro's "Question 01 OF N". */
  function visibleQuestionTotal() {
    var n = 0;
    for (var i = 0; i < STEPS.length; i++) {
      var s = STEPS[i];
      if ((s.type === 'q' || s.type === 'intro') && isStepVisible(s)) n++;
    }
    return n;
  }
  function visibleQuestionPos(stepIdx) {
    var n = 0;
    for (var i = 0; i <= stepIdx && i < STEPS.length; i++) {
      var s = STEPS[i];
      if ((s.type === 'q' || s.type === 'intro') && isStepVisible(s)) n++;
    }
    return n;
  }
  /* Remembered across renders so the bar animates from its previous value
     to the new target instead of restarting at 0% on every question. */
  var lastProgress = 0;
  function progressFillMarkup() {
    var progress = computeProgressPercent();
    return '<div class="progress-bar"><div class="progress-fill" style="width:' + lastProgress + '%" data-progress-from="' + lastProgress + '%" data-progress-target="' + progress + '%"></div></div>';
  }

  /* ============== QUESTION VIEW ============== */
  function viewQuestion(q) {
    var value = state.answers[q.id];
    var canContinue;
    if (q.kind === 'chips') {
      canContinue = !!(value && value.length > 0);
    } else if (q.kind === 'number') {
      canContinue = typeof value === 'number' && value >= (q.min || 1) && value <= (q.max || 999);
    } else {
      canContinue = value !== undefined && value !== null;
    }
    /* Chips and number don't auto-advance — chips needs an explicit Continue
       (multi-select), number needs the user to finish typing before nav. */
    var autoAdvance = q.kind !== 'chips' && q.kind !== 'number';
    var optionsHtml = '';

    if (q.kind === 'radio') {
      optionsHtml = '<div class="options">' + q.options.map(function (o, i) {
        var sel = value === o.v;
        return '<button class="option' + (sel ? ' selected' : '') + '" data-action="answer-radio" data-value="' + esc(o.v) + '" style="animation-delay:' + (i * 60) + 'ms">' +
          '<span class="label"><div>' + esc(o.label) + '</div>' + (o.tag ? '<div class="tag">' + esc(o.tag) + '</div>' : '') + '</span>' +
          '<span class="check">' + (sel ? '✓' : '') + '</span>' +
          '</button>';
      }).join('') + '</div>';
    } else if (q.kind === 'severity') {
      optionsHtml = '<div class="severity">' + q.scale.map(function (s) {
        var sel = value === s.v;
        return '<button class="severity-cell' + (sel ? ' selected' : '') + '" data-action="answer-severity" data-value="' + esc(s.v) + '">' +
          '<span class="sev-num">' + esc(s.v) + '</span><span class="sev-label">' + esc(s.label) + '</span></button>';
      }).join('') + '</div>' +
        '<div style="display:flex;justify-content:space-between;font-family:var(--mono);font-size:10px;color:var(--ink-3);margin-top:12px;letter-spacing:.14em;text-transform:uppercase">' +
        '<span>Quiet</span><span>Screaming</span></div>';
    } else if (q.kind === 'pills') {
      optionsHtml = '<div class="pills">' + q.options.map(function (o) {
        var sel = value === o.v;
        return '<button class="pill' + (sel ? ' selected' : '') + '" data-action="answer-pills" data-value="' + esc(o.v) + '">' +
          '<span class="big">' + esc(o.big) + '</span><span class="small">' + esc(o.small) + '</span></button>';
      }).join('') + '</div>';
    } else if (q.kind === 'chips') {
      var arr = value || [];
      optionsHtml = '<div class="chips">' + q.options.map(function (o) {
        var on = arr.indexOf(o.v) !== -1;
        return '<button class="chip' + (on ? ' selected' : '') + '" data-action="answer-chip" data-value="' + esc(o.v) + '">' +
          esc(o.label) + (on ? ' <span class="x">✓</span>' : '') + '</button>';
      }).join('') + '</div>';
    } else if (q.kind === 'yesno') {
      optionsHtml = '<div class="yesno">' + q.options.map(function (o, i) {
        var sel = value === o.v;
        return '<button class="yesno-cell' + (sel ? ' selected' : '') + '" data-action="answer-yesno" data-value="' + esc(o.v) + '" style="animation-delay:' + (i * 80) + 'ms">' +
          '<span class="yn-label">' + esc(o.label) + '</span>' +
          (o.tag ? '<span class="yn-tag">' + esc(o.tag) + '</span>' : '') +
          '</button>';
      }).join('') + '</div>';
    } else if (q.kind === 'number') {
      var displayVal = (value === undefined || value === null) ? '' : value;
      var minA = q.min != null ? ' min="' + esc(q.min) + '"' : '';
      var maxA = q.max != null ? ' max="' + esc(q.max) + '"' : '';
      optionsHtml = '<div class="numfield">' +
        '<div class="nf-input-wrap">' +
          '<input type="number" inputmode="numeric" pattern="[0-9]*" class="nf-input" data-action="answer-number"' +
            ' placeholder="' + esc(q.placeholder || 'Enter a number') + '"' + minA + maxA +
            ' value="' + esc(displayVal) + '" autofocus>' +
          (q.unit ? '<span class="nf-unit">' + esc(q.unit) + '</span>' : '') +
        '</div>' +
        (q.min != null && q.max != null ? '<div class="nf-range">Typical range ' + esc(q.min) + '–' + esc(q.max) + (q.unit ? ' ' + esc(q.unit) : '') + '</div>' : '') +
      '</div>';
    }

    var heroHtml = '';
    if (q.imageHero) {
      heroHtml = '<div class="q-hero-img' + (q.heroTransparent ? ' is-floating' : '') + (q.heroBare ? ' is-bare' : '') + '">' +
        imgTag(q.imageHero, '', { style: 'object-fit:contain' }) + '</div>';
    }

    var hasHero = q.imageHero && !q.heroTransparent;
    var visiblePos = visibleQuestionPos(state.step);
    var visibleTotal = visibleQuestionTotal();
    /* The data.js eyebrows hard-code the original question position (e.g.
       "Question 03 · Recent direction"), but the actual flow order differs
       because gained_year is grouped after stop_plan in STEPS. Replace the
       "Question NN" prefix with the live visible position so the eyebrow
       always agrees with the "N / TOTAL" counter on the right. */
    var eyebrowDisplay = (q.eyebrow || '').replace(/^Question\s+\d+/i, 'Question ' + String(visiblePos).padStart(2, '0'));

    return [
      '<div class="quiz-shell">',
      '  <div class="top-bar">',
      '    <button class="back-btn" data-action="back">← Back</button>',
      '    <div class="brand"><em>rejuveen</em></div>',
      '    <button class="skip-btn" data-action="next">Skip</button>',
      '  </div>',
      '  <div class="progress-wrap">',
      '    <div class="progress-meta"><span>' + esc(eyebrowDisplay) + '</span><span>' + visiblePos + ' / ' + visibleTotal + '</span></div>',
      '    ' + progressFillMarkup(),
      '  </div>',
      '  <div class="quiz-body">',
      '    <div class="screen' + (hasHero ? ' has-hero' : '') + '" data-screen-label="Q' + String(visiblePos).padStart(2, '0') + '">',
      heroHtml,
      '      <h1 class="q-title">' + q.title + '</h1>',
      q.sub ? '<p class="q-sub">' + esc(q.sub) + '</p>' : '',
      optionsHtml,
      '    </div>',
      '  </div>',
      '  <div class="quiz-footer">',
      (q.kind === 'chips' && !canContinue) ? '<div class="footer-hint">Select at least one option</div>' : '',
      '    <button class="btn-primary' + (autoAdvance ? ' is-skip-next' : '') + '" data-action="next"' + (canContinue ? '' : ' disabled') + '>' +
        (autoAdvance ? 'Skip to next' : 'Continue') + ' <span class="arrow">→</span></button>',
      '  </div>',
      '</div>',
    ].join('');
  }

  /* ============== EDU STAT ============== */
  function viewEduStat(data, idx, total) {
    return [
      '<div class="quiz-shell">',
      '  <div class="top-bar">',
      '    <button class="back-btn" data-action="back">← Back</button>',
      '    <div class="brand"><em>rejuveen</em></div>',
      '    <span style="width:30px"></span>',
      '  </div>',
      '  <div class="progress-wrap">',
      '    <div class="progress-meta"><span>Insight</span><span>...</span></div>',
      '    ' + progressFillMarkup(),
      '  </div>',
      '  <div class="quiz-body">',
      '    <div class="edu">',
      '      <div class="edu-badge"><span class="dot"></span>' + esc(data.badge) + '</div>',
      '      <h1 class="q-title" style="font-size:26px">' + (data.label || '') + '</h1>',
      data.image ? '<div class="edu-hero-img">' + imgTag(data.image, '', { style: 'object-fit:contain' }) + '</div>' : '',
      '      <div class="stat-hero" data-count-target="' + data.num + '">0<span class="pct">' + esc(data.suffix) + '</span></div>',
      '      <div class="stat-cap">' + esc(data.cap) + '</div>',
      '      <div class="stat-source">' + esc(data.source) + '</div>',
      data.extra ? '<div class="stat-source" style="border-top:none;padding-top:6px;color:var(--orange);font-weight:600">' + esc(data.extra) + '</div>' : '',
      '    </div>',
      '  </div>',
      '  <div class="quiz-footer">',
      '    <button class="btn-primary" data-action="next">I want to know more <span class="arrow">→</span></button>',
      '  </div>',
      '</div>',
    ].join('');
  }

  /* ============== EDU TRIGGERS ============== */
  /* "Rebound cascade" interstitial — rework design: icon grid (4 triggers)
     that reveals one at a time. Continue unlocks after all icons appear. */
  function viewEduTriggers(data) {
    var iconRow  = data.iconRow  || [];
    var triggers = data.triggers || [];
    var revealTotal = iconRow.length || triggers.length;

    /* Icon grid (new rework design) */
    var iconRowHtml = iconRow.length ? (
      '<div class="edu-icon-row">' +
      iconRow.map(function (it) {
        return '<div class="edu-icon-item" data-edu-reveal style="opacity:0;transform:translateY(12px) scale(0.9)">' +
          '<div class="edu-icon-art" aria-hidden="true"><img src="' + esc(it.art) + '" alt="" loading="eager"></div>' +
          '<div class="edu-icon-label">' + esc(it.name) + '</div>' +
        '</div>';
      }).join('') +
      '</div>'
    ) : '';

    /* Legacy trigger cards (kept for backwards compatibility, empty in rework) */
    var cardsHtml = triggers.length ? (
      '<div class="edu-trig-stack">' +
      triggers.map(function (t) {
        var roleClass    = 'is-' + (t.role || 'downstream');
        var roleLblClass = 'role-' + (t.role || 'downstream');
        return '<div class="edu-trig-card ' + roleClass + '" data-edu-reveal style="opacity:0;transform:translateY(14px)">' +
          (t.roleLabel ? '<div class="edu-trig-role ' + roleLblClass + '">' + esc(t.roleLabel) + '</div>' : '') +
          '<div class="edu-trig-head">' +
            (t.art ? '<div class="edu-trig-icon" aria-hidden="true">' + imgTag(t.art, '') + '</div>' : '') +
            '<div class="edu-trig-head-text">' +
              '<span class="edu-trig-num">Stage ' + String(t.n).padStart(2, '0') + '</span>' +
              '<span class="edu-trig-name">' + esc(t.name) + '</span>' +
            '</div>' +
          '</div>' +
          (t.headline ? '<div class="edu-trig-headline">' + esc(t.headline) + '</div>' : '') +
          (t.body     ? '<div class="edu-trig-txt">'      + esc(t.body)     + '</div>' : '') +
          (t.stat     ? '<div class="edu-trig-stat"><span class="edu-trig-stat-icon">📊</span> ' + esc(t.stat) + '</div>' : '') +
        '</div>';
      }).join('') +
      '</div>'
    ) : '';

    var footerHtml = data.footer ? (
      '<div class="edu-cascade-footer">' +
        '<div class="edu-cascade-footer-title">' + esc(data.footer.title) + '</div>' +
        '<div class="edu-cascade-footer-sub">'   + esc(data.footer.sub)   + '</div>' +
      '</div>'
    ) : '';

    var eduClass = iconRow.length ? 'edu edu-textonly' : 'edu';

    return [
      '<div class="quiz-shell">',
      '  <div class="top-bar">',
      '    <button class="back-btn" data-action="back">← Back</button>',
      '    <div class="brand"><em>rejuveen</em></div>',
      '    <span style="width:30px"></span>',
      '  </div>',
      '  <div class="progress-wrap">',
      '    <div class="progress-meta"><span>The Breakdown</span><span>...</span></div>',
      '    ' + progressFillMarkup(),
      '  </div>',
      '  <div class="quiz-body">',
      '    <div class="' + eduClass + '">',
      '      <div class="edu-badge"><span class="dot"></span>' + esc(data.badge || '') + '</div>',
      '      <h1 class="q-title edu-cascade-headline">' + esc(data.label || '') + '</h1>',
      (data.labelTail ? '<p class="edu-cascade-tail">' + esc(data.labelTail) + '</p>' : ''),
      (data.sub       ? '<p class="q-sub edu-cascade-sub">' + esc(data.sub) + '</p>' : ''),
      iconRowHtml,
      cardsHtml,
      footerHtml,
      '    </div>',
      '  </div>',
      '  <div class="quiz-footer">',
      '    <button class="btn-primary" data-action="next"' + (revealTotal > 0 ? ' disabled' : '') + '>Continue the diagnostic <span class="arrow">→</span></button>',
      '  </div>',
      '</div>',
    ].join('');
  }

  /* ============== MID-BREAK ==============
     Personalized SVG forecast chart driven by current_weight + goal_weight.
     Mirrors the math used on the Results dx-graph (Phase 3) so both screens
     tell the same projection story — only staging differs. When weights
     aren't both present or cw <= gw, the chart degrades to a smaller link
     card; the 75.3% Lancet stat callout always renders so the evidence is
     never suppressed by missing inputs. */
  function midbreakChart(cw, gw) {
    if (!cw || !gw || cw <= gw) return null;
    var toGo = cw - gw;
    var W = 720, H = 380, padL = 50, padR = 30, padT = 70, padB = 56;
    var innerW = W - padL - padR;
    var innerH = H - padT - padB;
    var baseline = padT + innerH;
    var reboundPeak = cw + Math.max(8, Math.round(toGo * 0.25));
    var yMin = Math.max(0, gw - 14);
    var yMax = reboundPeak + 6;
    function yScale(v) { return padT + innerH - ((v - yMin) / (yMax - yMin || 1)) * innerH; }
    function xScale(m) { return padL + (m / 12) * innerW; }
    /* 49-point sample · matches Results dx-graph curve resolution. */
    var N = 49;
    var protocolPts = [];
    var reboundPts = [];
    for (var i = 0; i < N; i++) {
      var m = (i * 12) / (N - 1);
      /* Protocol curve: smooth ease-out from cw to gw over months 0–6, then hold. */
      var tp = Math.min(1, m / 6);
      var easeP = 1 - Math.pow(1 - tp, 2);
      protocolPts.push({ m: m, y: cw - (cw - gw) * easeP });
      /* Rebound curve: drop to gw by month 4, then climb to reboundPeak by month 12. */
      var ry;
      if (m <= 4) {
        var tr = m / 4;
        ry = cw - (cw - gw) * (1 - Math.pow(1 - tr, 2));
      } else {
        var tr2 = (m - 4) / 8;
        ry = gw + (reboundPeak - gw) * (1 - Math.pow(1 - tr2, 1.4));
      }
      reboundPts.push({ m: m, y: ry });
    }
    function toPath(pts) {
      var d = '';
      for (var i2 = 0; i2 < pts.length; i2++) {
        d += (i2 === 0 ? 'M' : 'L') + xScale(pts[i2].m).toFixed(1) + ',' + yScale(pts[i2].y).toFixed(1) + ' ';
      }
      return d.trim();
    }
    var protocolPath = toPath(protocolPts);
    var reboundPath = toPath(reboundPts);
    var xStart = xScale(0), yStart = yScale(cw);
    var xEnd = xScale(12);
    var yProtoEnd = yScale(gw);
    var yReboundEnd = yScale(reboundPeak);
    var startTxt = cw + ' LB', goalTxt = gw + ' LB', peakTxt = reboundPeak + ' LB';
    function pillW(s) { return Math.max(78, s.length * 14 + 22); }
    var months = [0, 3, 6, 9, 12];

    /* Build SVG markup */
    var svg = '<svg viewBox="0 0 ' + W + ' ' + H + '" class="mb-chart-svg" preserveAspectRatio="xMidYMid meet"' +
      ' aria-label="Forecast graph: with protocol support, weight reaches ' + gw + ' lbs by month 6 and holds. Without protocol support, weight rebounds to ' + reboundPeak + ' lbs by month 12.">';
    svg += '<defs><linearGradient id="mbAreaGrad" x1="0" x2="0" y1="0" y2="1">' +
      '<stop offset="0%" stop-color="#3F7A4F" stop-opacity="0.22"/>' +
      '<stop offset="100%" stop-color="#3F7A4F" stop-opacity="0"/>' +
      '</linearGradient></defs>';
    /* gridlines */
    months.forEach(function (m) {
      svg += '<line x1="' + xScale(m) + '" x2="' + xScale(m) + '" y1="' + padT + '" y2="' + baseline + '" stroke="#EFE6D6" stroke-width="1" />';
    });
    /* current dashed reference */
    svg += '<line x1="' + padL + '" x2="' + (W - padR) + '" y1="' + yStart + '" y2="' + yStart + '" stroke="#D8C9A8" stroke-width="1.2" stroke-dasharray="4 5" />';
    /* goal dashed reference */
    svg += '<line x1="' + padL + '" x2="' + (W - padR) + '" y1="' + yProtoEnd + '" y2="' + yProtoEnd + '" stroke="#C8B891" stroke-width="1.2" stroke-dasharray="4 5" />';
    /* gradient area fill under green curve */
    svg += '<path d="' + protocolPath + ' L' + xEnd.toFixed(1) + ',' + baseline + ' L' + xStart.toFixed(1) + ',' + baseline + ' Z" fill="url(#mbAreaGrad)" class="mb-area-fill" />';
    /* PROTOCOL (green) */
    svg += '<path d="' + protocolPath + '" fill="none" stroke="#3F7A4F" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" pathLength="1" class="mb-line mb-line-green" />';
    /* REBOUND (red) */
    svg += '<path d="' + reboundPath + '" fill="none" stroke="#C74827" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" pathLength="1" class="mb-line mb-line-red" />';
    /* x labels */
    svg += '<text x="' + xScale(0) + '" y="' + (H - 18) + '" text-anchor="start" font-size="20" fill="#8A7F75" font-family="JetBrains Mono, monospace" font-weight="700">TODAY</text>';
    svg += '<text x="' + xScale(12) + '" y="' + (H - 18) + '" text-anchor="end" font-size="20" fill="#8A7F75" font-family="JetBrains Mono, monospace" font-weight="700">MONTH 12</text>';
    [3, 6, 9].forEach(function (m) {
      svg += '<text x="' + xScale(m) + '" y="' + (H - 18) + '" text-anchor="middle" font-size="16" fill="#B0A695" font-family="JetBrains Mono, monospace">M' + m + '</text>';
    });
    /* START PILL (cw, above the start point) */
    var startPillW = pillW(startTxt);
    svg += '<g class="mb-pill mb-pill-1">' +
      '<rect x="' + (xStart - startPillW / 2) + '" y="' + (yStart - 70) + '" width="' + startPillW + '" height="44" rx="9" fill="#1E1A15"/>' +
      '<text x="' + xStart + '" y="' + (yStart - 41) + '" text-anchor="middle" fill="#FFF6E5" font-size="22" font-weight="700" font-family="Inter Tight, sans-serif" letter-spacing="0.02em">' + startTxt + '</text>' +
      '<line x1="' + xStart + '" y1="' + (yStart - 26) + '" x2="' + xStart + '" y2="' + (yStart - 9) + '" stroke="#1E1A15" stroke-width="2.5"/>' +
      '<circle cx="' + xStart + '" cy="' + yStart + '" r="8" fill="#1E1A15"/>' +
    '</g>';
    /* GOAL PILL (green endpoint, to the LEFT of dot) */
    var goalPillW = pillW(goalTxt);
    svg += '<g class="mb-pill mb-pill-2">' +
      '<rect x="' + (xEnd - goalPillW - 24) + '" y="' + (yProtoEnd - 22) + '" width="' + goalPillW + '" height="44" rx="9" fill="#1E1A15"/>' +
      '<text x="' + (xEnd - goalPillW / 2 - 24) + '" y="' + (yProtoEnd + 8) + '" text-anchor="middle" fill="#FFF6E5" font-size="22" font-weight="700" font-family="Inter Tight, sans-serif" letter-spacing="0.02em">' + goalTxt + '</text>' +
      '<line x1="' + (xEnd - 24) + '" y1="' + yProtoEnd + '" x2="' + (xEnd - 9) + '" y2="' + yProtoEnd + '" stroke="#1E1A15" stroke-width="2.5"/>' +
      '<circle cx="' + xEnd + '" cy="' + yProtoEnd + '" r="8" fill="#3F7A4F" stroke="#FFF" stroke-width="2.5"/>' +
    '</g>';
    /* "YOU STOP THE SHOT" callout at month 4 inflection */
    var xStop = xScale(4);
    var yStop = yScale(gw);
    var labelW = 250, labelH = 40;
    var labelX = xStop - labelW / 2;
    var labelY = yStop + 28;
    var arrowEndY = yStop + 10;
    var arrowMidY = (labelY + arrowEndY) / 2;
    svg += '<g class="mb-pill mb-pill-stop">' +
      '<rect x="' + labelX + '" y="' + labelY + '" width="' + labelW + '" height="' + labelH + '" rx="8" fill="#1E1A15"/>' +
      '<text x="' + xStop + '" y="' + (labelY + 26) + '" text-anchor="middle" fill="#FFF6E5" font-size="18" font-weight="700" font-family="JetBrains Mono, monospace" letter-spacing="0.06em">YOU STOP THE SHOT</text>' +
      '<path d="M' + xStop + ',' + labelY + ' C' + xStop + ',' + arrowMidY + ' ' + xStop + ',' + arrowMidY + ' ' + xStop + ',' + arrowEndY + '" fill="none" stroke="#1E1A15" stroke-width="2.5" stroke-linecap="round"/>' +
      '<polygon points="' + (xStop - 6) + ',' + (arrowEndY - 8) + ' ' + (xStop + 6) + ',' + (arrowEndY - 8) + ' ' + xStop + ',' + (arrowEndY + 2) + '" fill="#1E1A15"/>' +
      '<circle cx="' + xStop + '" cy="' + yStop + '" r="6" fill="#C74827" stroke="#FFF" stroke-width="2.5"/>' +
    '</g>';
    /* REBOUND PEAK PILL (red endpoint, to the LEFT of dot) */
    var peakPillW = pillW(peakTxt);
    svg += '<g class="mb-pill mb-pill-3">' +
      '<rect x="' + (xEnd - peakPillW - 24) + '" y="' + (yReboundEnd - 22) + '" width="' + peakPillW + '" height="44" rx="9" fill="#C74827"/>' +
      '<text x="' + (xEnd - peakPillW / 2 - 24) + '" y="' + (yReboundEnd + 8) + '" text-anchor="middle" fill="#FFF6E5" font-size="22" font-weight="700" font-family="Inter Tight, sans-serif" letter-spacing="0.02em">' + peakTxt + '</text>' +
      '<line x1="' + (xEnd - 24) + '" y1="' + yReboundEnd + '" x2="' + (xEnd - 9) + '" y2="' + yReboundEnd + '" stroke="#C74827" stroke-width="2.5"/>' +
      '<circle cx="' + xEnd + '" cy="' + yReboundEnd + '" r="8" fill="#C74827" stroke="#FFF" stroke-width="2.5"/>' +
    '</g>';
    svg += '</svg>';
    return { svg: svg, reboundPeak: reboundPeak, toGo: toGo };
  }

  function viewMidBreak() {
    var data = MIDBREAK;
    var cw = Number(state.answers.current_weight) || 0;
    var gw = Number(state.answers.goal_weight) || 0;
    var toGo = Math.max(0, cw - gw);
    var chart = midbreakChart(cw, gw);

    /* Body blocks: alternating paragraphs and bullet arrays per MIDBREAK.body. */
    var bodyHtml = data.body.map(function (block) {
      if (Array.isArray(block)) {
        return '<ul class="mb-bullets">' + block.map(function (t) {
          return '<li><span class="mb-tick">✓</span>' + esc(t) + '</li>';
        }).join('') + '</ul>';
      }
      return '<p class="mb-p">' + esc(block) + '</p>';
    }).join('');

    var chartHtml = '';
    if (chart) {
      chartHtml = '' +
        '<div class="mb-chart-card">' +
          '<div class="mb-chart-eyebrow">YOUR PROJECTION · BASED ON YOUR ANSWERS</div>' +
          '<div class="mb-chart-headline">From <strong>' + cw + ' lbs</strong> to <strong>' + gw + ' lbs</strong>... and what happens after.</div>' +
          '<div class="mb-chart-foot-top">' + toGo + ' lbs to go · this is the number we\'re locking your protocol to.</div>' +
          '<div class="mb-chart-svg-wrap">' + chart.svg + '</div>' +
          '<div class="mb-chart-legend">' +
            '<div class="mb-leg mb-leg-green"><span class="mb-leg-dot"></span><div>' +
              '<div class="mb-leg-name">With protocol support</div>' +
              '<div class="mb-leg-sub">Reaches ' + gw + ' lbs by month 6 · holds the line</div>' +
            '</div></div>' +
            '<div class="mb-leg mb-leg-red"><span class="mb-leg-dot"></span><div>' +
              '<div class="mb-leg-name">Without it</div>' +
              '<div class="mb-leg-sub">Climbs to ' + chart.reboundPeak + ' lbs by month 12</div>' +
            '</div></div>' +
          '</div>' +
        '</div>';
    } else if (toGo > 0) {
      /* Fallback when goal_weight not set yet or cw <= gw: smaller link card,
         no chart. */
      chartHtml = '' +
        '<div class="mb-link-card">' +
          '<div class="mb-link-row">' +
            '<div class="mb-link-col"><div class="mb-link-num">' + cw + '<span>lbs</span></div><div class="mb-link-lbl">Where you are</div></div>' +
            '<div class="mb-link-arrow">→</div>' +
            '<div class="mb-link-col"><div class="mb-link-num">' + gw + '<span>lbs</span></div><div class="mb-link-lbl">Where you want to be</div></div>' +
          '</div>' +
          '<div class="mb-link-foot">' + toGo + ' lbs to go · this is the number we\'re locking your protocol to.</div>' +
        '</div>';
    }

    /* 75.3% Lancet callout. Renders on every MidBreak — the evidence story is
       independent of whether we can personalize the chart. */
    var statHtml =
      '<div class="mb-chart-stat ' + (chart ? 'mb-chart-stat-with-chart' : 'mb-chart-stat-standalone') + '">' +
        '<div class="mb-chart-stat-num">75.3<span class="mb-chart-stat-pct">%</span></div>' +
        '<div class="mb-chart-stat-cap">of weight lost on the shot is plateaued back beyond 52 weeks. <em>Lancet eClinicalMedicine, March 2026.</em></div>' +
      '</div>';

    var imageHtml = data.image ?
      '<div class="mb-image">' + imgTag(data.image, 'Rejuveen Provitalean bottle') + '</div>' : '';

    return [
      '<div class="quiz-shell">',
      '  <div class="top-bar">',
      '    <button class="back-btn" data-action="back">← Back</button>',
      '    <div class="brand"><em>rejuveen</em></div>',
      '    <span style="width:30px"></span>',
      '  </div>',
      '  <div class="progress-wrap">',
      '    <div class="progress-meta"><span>Mid-break</span><span>...</span></div>',
      '    ' + progressFillMarkup(),
      '  </div>',
      '  <div class="quiz-body">',
      '    <div class="midbreak">',
      '      <div class="mb-badge"><span class="dot"></span>' + esc(data.badge) + '</div>',
      '      <h1 class="mb-title">' + data.title + '</h1>',
      chartHtml,
      statHtml,
      imageHtml,
      bodyHtml,
      '    </div>',
      '  </div>',
      '  <div class="quiz-footer">',
      '    <button class="btn-primary" data-action="next">' + esc(data.cta || 'Continue') + ' <span class="arrow">→</span></button>',
      '  </div>',
      '</div>',
    ].join('');
  }

  /* ============== ANALYZING ============== */
  function viewAnalyzing() {
    var steps = [
      'Analyzing your responses',
      'Comparing against 12,400 program outcomes',
      'Matching you with the right protocol',
      'Calibrating your 90-day projection',
      'Preparing your case file',
    ];
    var reviews = getTestimonials();
    var reviewsHtml = reviews.map(function (r, i) {
      return '<figure class="analyze-review' + (i === 0 ? ' is-active' : '') + '" aria-hidden="' + (i === 0 ? 'false' : 'true') + '">' +
        '<div class="ar-stars" aria-hidden="true">★★★★★</div>' +
        '<p class="ar-quote">"' + esc(r.quote) + '"</p>' +
        '<figcaption class="ar-who">' +
          '<img src="' + esc(r.img) + '" alt="' + esc(r.name) + '" loading="eager">' +
          '<span><strong>' + esc(r.name) + '</strong> · ' + esc(r.detail) + '</span>' +
        '</figcaption>' +
      '</figure>';
    }).join('');
    var dotsHtml = reviews.map(function (_, i) {
      return '<span class="arv-dot' + (i === 0 ? ' active' : '') + '"></span>';
    }).join('');
    var pipsHtml = steps.map(function (_, i) {
      return '<span class="analyze-pip' + (i === 0 ? ' active' : '') + '"></span>';
    }).join('');
    return [
      '<div class="quiz-shell">',
      '  <div class="analyze-stage">',
      '    <div class="analyze-reviews analyze-reviews-hero" aria-live="polite">',
      '      <div class="analyze-reviews-eyebrow">While we build your protocol</div>',
      '      <div class="analyze-reviews-stack">' + reviewsHtml + '</div>',
      '      <div class="analyze-reviews-dots" aria-hidden="true">' + dotsHtml + '</div>',
      '    </div>',
      '    <div class="analyze-solo">',
      '      <div class="analyze-solo-meta" id="an-meta">Step 1 of ' + steps.length + '</div>',
      '      <div class="analyze-solo-text" id="an-text">' + esc(steps[0]) + '<span class="analyze-dots" aria-hidden="true"><span></span><span></span><span></span></span></div>',
      '      <div class="analyze-solo-bar"><div class="analyze-solo-fill" id="an-fill" style="width:0%"></div></div>',
      '      <div class="analyze-pip-row" aria-hidden="true">' + pipsHtml + '</div>',
      '    </div>',
      '  </div>',
      '</div>',
    ].join('');
  }

  /* ============== PROFILES ============== */
  /* Three profile archetypes mirror the React reference. Highest score wins;
     ties break toward Rebound (the universal recommendation for any GLP-1
     user thinking about an off-ramp). The blurb lives as an HTML string
     because the React JSX uses tags inside it. */
  var PROFILES = {
    rebound: {
      key: 'rebound',
      name: 'The Rebound Risk',
      subtitle: 'Your gut bacteria are 60–90 days from collapse. When the satiety strains crash, the food noise comes back. Not gradually... all at once. Like a switch.',
      blurb: [
        '<p class="blurb-lead">The shot quiets your appetite by amplifying your gut-hormone signals. But here\'s what no one explains:</p>',
        '<p><strong>Your weekly injection slowly starves Akkermansia muciniphila</strong>... the keystone bacteria that <em>naturally</em> produces your body\'s own satiety signal.</p>',
        '<ul class="blurb-bullets">',
        '<li><strong>The day you taper or skip a dose</strong> ... that satiety signal disappears.</li>',
        '<li><strong>The cravings flood back.</strong> Not gradually. All at once.</li>',
        '<li><strong>75.3% of the weight lost is plateaued back past 52 weeks.</strong> <span class="blurb-src">Lancet, March 2026</span></li>',
        '</ul>',
        '<p class="blurb-reframe">Right now you\'re chemically thin. <em>The goal is to be biologically thin.</em></p>',
        '<div class="blurb-divider"></div>',
        '<p class="blurb-lead"><strong>The villain isn\'t the shot.</strong> The shot works. The problem is being prescribed it without the gut support to keep it working.</p>',
        '<p>Your protocol rebuilds the satiety strains your microbiome lost first:</p>',
        '<ul class="blurb-bullets">',
        '<li><strong>B. lactis B420™ + L. rhamnosus GG</strong> ... the satiety strains the shot quietly depleted.</li>',
        '<li><strong>Akkermansia rebuilders</strong> ... so your body keeps producing its own appetite signal even when the injection isn\'t doing it for you.</li>',
        '</ul>',
        '<p class="blurb-closer">You stop renting your body for $975/month and start owning it for $1.63/day.</p>',
      ].join(''),
      primaryIngredients: ['b420', 'rhamnosus', 'lactis'],
      cta: 'Lock in the loss before the rebound starts',
    },
    muscle: {
      key: 'muscle',
      name: 'The Muscle Saver',
      subtitle: "The scale said you won. Your body said you lost. Without the satiety strains, your metabolism can't tell fat from muscle... so it burns both.",
      blurb: [
        '<p class="blurb-lead">The scale said you won. Your body said you lost.</p>',
        '<p><strong>Up to 40% of the weight lost on the shot is lean muscle.</strong> <span class="blurb-src">Harvard Science Review, Feb 2026</span></p>',
        '<p>It\'s the look women have been calling <em>"pancake butt, bat-wing arms, shot-face."</em> A smaller body that somehow looks softer, weaker, and older than the heavier one did.</p>',
        '<p>Why 140g of protein a day still leaves your arms looking deflated:</p>',
        '<ul class="blurb-bullets">',
        '<li><strong>Slowed gastric emptying</strong> breaks butyrate production.</li>',
        '<li><strong>The Protein Thermostat shuts off</strong> ... most of that protein gets flushed away as expensive pee.</li>',
        '<li><strong>Without the satiety strains</strong>, your metabolism can\'t tell fat from muscle, so it burns both.</li>',
        '</ul>',
        '<div class="blurb-divider"></div>',
        '<p class="blurb-lead">Your protocol rebuilds shape, not just size:</p>',
        '<ul class="blurb-bullets">',
        '<li><strong>B. lactis B420™</strong> ... clinically shown to support lean-mass retention during weight loss.</li>',
        '<li><strong>Chromium (571% DV)</strong> ... keeps blood sugar stable so your body burns fat for fuel, not muscle.</li>',
        '<li><strong>L. rhamnosus GG</strong> ... quiets the appetite signal so you can actually absorb the protein you\'re eating instead of fighting food noise on top of it.</li>',
        '</ul>',
      ].join(''),
      primaryIngredients: ['b420', 'chromium', 'rhamnosus'],
      cta: 'Stop the muscle loss · rebuild your shape',
    },
    belly: {
      key: 'belly',
      name: 'The Abdominal Holdout',
      subtitle: "Your face and arms shrunk. The abdomen didn't. It's not willpower. It's bacterial.",
      blurb: [
        '<p class="blurb-lead">Your face and arms shrunk. The abdomen didn\'t. It\'s not willpower. It\'s bacterial.</p>',
        '<p><strong>Hinte 2024 (Nature)</strong> proved your fat cells keep an <strong>epigenetic memory of obesity</strong>... primed to refill the moment satiety signals fade.</p>',
        '<p>And visceral abdominal fat is metabolically different from the fat you lost on your arms and face:</p>',
        '<ul class="blurb-bullets">',
        '<li><strong>Protected by a downshifted AMPK switch</strong> ... what we call AMPK Dormancy.</li>',
        '<li><strong>That\'s exactly why every diet you\'ve tried</strong> plateaued at the same waist measurement.</li>',
        '<li><strong>Hit your goal weight. Look worse naked.</strong> WTF is happening? <em>This is what.</em></li>',
        '</ul>',
        '<div class="blurb-divider"></div>',
        '<p class="blurb-lead">Your protocol reactivates the switch abdominal fat is hiding behind:</p>',
        '<ul class="blurb-bullets">',
        '<li><strong>Morosil® Red Orange</strong> ... the only ingredient clinically shown to support a <strong>2.5cm waist reduction in 12 weeks</strong> by reactivating AMPK (your fat-burning switch).</li>',
        '<li><strong>Hibiscus extract</strong> ... supports healthy carb metabolism.</li>',
        '<li><strong>Chromium</strong> ... helps reduce sugar cravings at the root.</li>',
        '</ul>',
      ].join(''),
      primaryIngredients: ['morosil', 'hibiscus', 'chromium'],
      cta: 'Finally move the abdominal fat',
    },
  };

  /* Diagnosis page data: root cause card and profile-specific trigger card. */
  var PROFILE_CARD_ART = {
    rebound: IMG.trigger_hunger_switch,
    muscle:  IMG.trigger_muscle_starvation,
    belly:   IMG.trigger_ampk_dormancy,
  };

  var DX_ROOT = {
    art:    IMG.trigger_gut_burnout,
    label:  'THE ROOT CAUSE',
    name:   'Gut Bacterial Burnout',
    lead:   "The keystone bacteria your body used to make its own \"I'm full\" signal are starving on the shot.",
    bullets: [
      'The injection amplifies your satiety hormones but never rebuilds the bacteria that produce them.',
      'Akkermansia muciniphila, your fullness keystone strain, thins out month after month on the shot.',
      'Based on your answers, your satiety strains are about 60 to 90 days from collapse.',
    ],
  };

  var DX_TRIGGER = {
    rebound: {
      art:       IMG.trigger_hunger_switch,
      connector: 'When the bacteria starve, the hunger switch flips back on.',
      label:     'WHAT THAT TRIGGERS',
      name:      'The Hunger Switch flips back on',
      lead:      'The day your dose drops, the food noise comes back. Not gradually. All at once.',
      bullets: [
        'With the satiety strains gone, nothing is left to quiet the cravings between doses.',
        'Lancet tracked 75.3% of the weight lost plateauing back past 52 weeks.',
      ],
    },
    muscle: {
      art:       IMG.trigger_muscle_starvation,
      connector: 'When the bacteria starve, your body starts burning muscle.',
      label:     'WHAT THAT TRIGGERS',
      name:      'Muscle Starvation Syndrome',
      lead:      "Without the satiety strains, your metabolism can't tell fat from muscle, so it burns both.",
      bullets: [
        'Up to 40% of the weight lost on the shot is lean muscle, not fat (Harvard Science Review).',
        'Slowed gastric emptying stalls butyrate, the fuel your lean-mass signal runs on, so the protein you eat gets flushed away.',
      ],
    },
    belly: {
      art:       IMG.trigger_ampk_dormancy,
      connector: 'When the bacteria starve, your abdominal fat digs in.',
      label:     'WHAT THAT TRIGGERS',
      name:      'AMPK Dormancy',
      lead:      'Visceral abdominal fat sits behind a downshifted AMPK switch, so it holds while your face and arms shrink.',
      bullets: [
        'Hinte 2024 (Nature) showed fat cells keep an epigenetic memory of obesity, primed to refill the moment satiety fades.',
        'That dormant AMPK switch is why every diet plateaued at the same waist measurement.',
      ],
    },
  };

  /* Profile scoring · same model as the new export. Each question contributes
     weight to one or more of three tracks: Rebound (R), Muscle (M), Belly
     (B). The highest score wins; ties break toward Rebound since it's the
     most universal recommendation for a GLP-1 user. body_areas + gi_symptoms
     are multi-select arrays — each chip contributes independently. */
  function computeProfile(answers) {
    var R = 0, M = 0, B = 0;

    if (answers.glp1 === 'off') R += 3;

    var dur = answers.duration;
    if (dur === '3to6')  { R += 1; M += 1; B += 1; }
    if (dur === '6to12') { R += 2; M += 2; B += 1; }
    if (dur === 'gt12')  { R += 2; M += 3; B += 2; }
    if (dur === 'past')  { R += 4; B += 1; }

    if (answers.gained_year === 'yes') { R += 3; B += 2; }

    var sp = answers.stop_plan;
    if (sp === 'taper-now')   R += 4;
    if (sp === 'soon')        R += 4;
    if (sp === 'staying')     M += 1;
    if (sp === 'undecided')   R += 2;
    if (sp === 'already-off') R += 5;

    var ba = Array.isArray(answers.body_areas) ? answers.body_areas : [];
    if (ba.indexOf('stomach')    !== -1) B += 4;
    if (ba.indexOf('hipsthighs') !== -1) B += 2;
    if (ba.indexOf('arms')       !== -1) M += 2;
    if (ba.indexOf('face')       !== -1) M += 2;
    if (ba.indexOf('whole')      !== -1) { M += 2; R += 2; }

    var mu = answers.muscle;
    if (mu === 'looser')   M += 2;
    if (mu === 'deflated') M += 4;
    if (mu === 'elephant') M += 5;
    if (mu === 'weaker')   M += 5;

    var fn = Number(answers.food_noise) || 0;
    if (fn >= 4)      R += 4;
    else if (fn === 3) R += 2;
    else if (fn <= 2 && fn > 0) M += 1;

    var gi = Array.isArray(answers.gi_symptoms) ? answers.gi_symptoms : [];
    var giCount = 0;
    for (var gIdx = 0; gIdx < gi.length; gIdx++) {
      if (gi[gIdx] !== 'nothing') giCount++;
    }
    R += Math.min(4, giCount);

    if (answers.meds_history === 'short')    R += 1;
    if (answers.meds_history === 'multiple') R += 3;
    if (answers.meds_history === 'ppi')      R += 4;

    if (answers.veggies === 'none') R += 3;
    if (answers.veggies === 'some') R += 1;

    var age = answers.age;
    if (age === '45-54') M += 1;
    if (age === '55-64') M += 2;
    if (age === '65+')   M += 3;

    var lost = answers.lost;
    if (lost === '15-30') { M += 1; B += 1; }
    if (lost === '30-50') { M += 2; B += 1; }
    if (lost === '50+')   { M += 3; B += 1; R += 1; }

    var cw = Number(answers.current_weight) || 0;
    var gw = Number(answers.goal_weight) || 0;
    var toGo = Math.max(0, cw - gw);
    if (toGo > 30) B += 2;
    if (toGo > 50) { R += 1; M += 1; }

    if (answers.exercise === 'none') M += 3;
    if (answers.exercise === 'low')  M += 1;

    var rg = answers.regain;
    if (rg === 'some')  R += 1;
    if (rg === 'all')   { R += 2; B += 2; }
    if (rg === 'worse') { R += 3; B += 3; }

    var g = answers.goal;
    if (g === 'no_rebound')  R += 5;
    if (g === 'quiet_noise') R += 5;
    if (g === 'rebuild')     M += 5;
    if (g === 'belly')       B += 5;

    var key = 'rebound';
    if (M > R && M >= B) key = 'muscle';
    else if (B > R && B > M) key = 'belly';

    var base = PROFILES[key];

    var medMap = { ozempic: 'Ozempic', wegovy: 'Wegovy', mounjaro: 'Mounjaro', zepbound: 'Zepbound', compounded: 'Mounjaro', off: 'a former shot plan' };
    var durMap = { lt3: 'under 3 months', '3to6': '3–6 months', '6to12': '6–12 months', gt12: 'over a year', past: 'previously' };
    var stopMap = { 'taper-now': 'tapering now', soon: 'planning to stop within 90 days', staying: 'staying on the shot', undecided: 'still deciding the off-ramp', 'already-off': 'already off the shot' };
    var fnLabel = ['', 'food noise barely there', 'food noise mostly quiet', 'food noise creeping back', 'food noise loud again', 'food noise screaming'];
    var muLabel = { strong: 'lean mass holding strong', looser: 'arms and inner thighs feel looser', deflated: 'classic deflated shot-face look', elephant: '"elephant butt" / saggy skin', weaker: 'visibly smaller AND weaker' };
    var baMap = { stomach: 'stomach', hipsthighs: 'hips & thighs', arms: 'arms', face: 'face', whole: 'whole body' };
    var giMap = { constipation: 'constipation', nausea: 'nausea / sulfur burps', bloating: 'bloating', fog: 'low energy / fog' };
    var lostLabel = { '<15': 'under 15 lbs lost', '15-30': '15–30 lbs lost', '30-50': '30–50 lbs lost', '50+': 'over 50 lbs lost' };

    var baLabel = ba.filter(function (v) { return v !== 'nothing'; }).map(function (v) { return baMap[v] || v; }).join(' + ') || null;
    var giLabel = gi.filter(function (v) { return v !== 'nothing'; }).map(function (v) { return giMap[v] || v; }).join(' · ') || null;

    var personalBullets = [];
    if (answers.glp1 && answers.duration) {
      personalBullets.push({ label: 'On ' + (medMap[answers.glp1] || 'the shot') + ' for ' + (durMap[answers.duration] || 'some time'), tag: stopMap[answers.stop_plan] || null });
    }
    if (answers.food_noise) {
      personalBullets.push({ label: fnLabel[answers.food_noise] || 'food noise tracked' });
    }
    if (key === 'muscle' && answers.muscle) {
      personalBullets.push({ label: muLabel[answers.muscle], tag: lostLabel[answers.lost] });
    } else if (key === 'belly' && baLabel) {
      personalBullets.push({ label: 'Holdout zones: ' + baLabel, tag: lostLabel[answers.lost] });
    } else if (answers.lost) {
      personalBullets.push({ label: lostLabel[answers.lost], tag: muLabel[answers.muscle] || baLabel });
    }

    return {
      key: base.key,
      name: base.name,
      subtitle: base.subtitle,
      blurb: base.blurb,
      primaryIngredients: base.primaryIngredients,
      cta: base.cta,
      personalBullets: personalBullets.slice(0, 3),
      scores: { R: R, M: M, B: B },
      derived: { toGo: toGo, baLabel: baLabel, giLabel: giLabel, giCount: giCount, cw: cw, gw: gw },
    };
  }

  /* "Personal Data File" — case-file UI that reads the user's answers back
     to them, framed as a clinical readout. Row set adapts to the branch:
       - glp1='off' shows "Time since stopping" instead of "Time on shot" +
         "Off-ramp plan" (those two are skipped via STEPS).
       - stop_plan='staying' skips "Gained in last year" (same skipIf logic).
     The denominator on the captured tag matches the rendered row count so
     the user always sees "N / N captured" even on branched paths. */
  function buildDataFileHtml(answers, profile) {
    var medMap   = { ozempic: 'Ozempic', wegovy: 'Wegovy', mounjaro: 'Mounjaro', zepbound: 'Zepbound', compounded: 'Compounded sema / tirz', off: 'Already off the shot' };
    var durMap   = { lt3: 'Under 3 months', '3to6': '3–6 months', '6to12': '6–12 months', gt12: 'Over a year', past: 'Already stopped' };
    var stopMap  = { 'taper-now': 'Tapering now', soon: 'Stopping within 90 days', staying: 'Staying on indefinitely', undecided: 'Not sure yet', 'already-off': 'Already off' };
    var muMap    = { strong: 'Strong & toned', looser: 'Looser arms / inner thighs', deflated: 'Hollow / deflated', elephant: 'Elephant butt / saggy', weaker: 'Smaller AND weaker' };
    var medsMap  = { none: 'None', short: 'Short antibiotic course', multiple: 'Multiple courses', ppi: 'PPIs / antacids · chronic' };
    var vegMap   = { none: "Doesn't eat veggies", some: 'Sometimes', daily: 'Every day', most: 'Mostly veggies' };
    var ageMap   = { '25-34': '25–34', '35-44': '35–44', '45-54': '45–54', '55-64': '55–64', '65+': '65+' };
    var lostMap  = { '<15': 'Under 15 lbs', '15-30': '15–30 lbs', '30-50': '30–50 lbs', '50+': 'Over 50 lbs' };
    var exMap    = { none: 'Little / none', low: '1–2 days a week', mid: '3–4 days a week', high: '5+ days a week' };
    var rgMap    = { first: 'First real loss', some: 'Some came back', all: 'All came back', worse: 'All + more, every cycle' };
    var goalMap  = { no_rebound: 'Keep results off the shot', quiet_noise: 'Silence the food noise', rebuild: 'Rebuild shape', belly: 'Lose abdominal fat' };
    var timeOffMap = { lt1: 'Less than 1 month ago', '1to3': '1–3 months ago', '3to6': '3–6 months ago', '6to12': '6–12 months ago', gt12: 'Over a year ago' };

    var offBranch = answers.glp1 === 'off';
    var stayingBranch = !offBranch && answers.stop_plan === 'staying';
    var cw = (profile.derived && profile.derived.cw) || Number(answers.current_weight) || 0;
    var gw = (profile.derived && profile.derived.gw) || Number(answers.goal_weight) || 0;
    var baLabel = profile.derived && profile.derived.baLabel;
    var giLabel = profile.derived && profile.derived.giLabel;
    var giNothing = Array.isArray(answers.gi_symptoms) && answers.gi_symptoms.indexOf('nothing') !== -1;

    /* Derive a stable case ID from a few of the numeric answers so the same
       user always sees the same file number. Six digits, zero-padded. */
    var probabilitySeed = (profile.scores && profile.scores.R) || 50;
    var caseId = String((probabilitySeed * 1000 + cw * 11 + gw * 7 + 1000000) % 1000000);
    while (caseId.length < 6) caseId = '0' + caseId;

    var rows = [];
    rows.push(['Medication',          medMap[answers.glp1] || 'Not provided']);
    if (offBranch) {
      rows.push(['Time since stopping', timeOffMap[answers.time_off] || 'Not provided']);
    } else {
      rows.push(['Time on shot',        durMap[answers.duration] || 'Not provided']);
    }
    if (!stayingBranch) {
      rows.push(['Gained in last year', answers.gained_year === 'yes' ? 'Yes' : answers.gained_year === 'no' ? 'No' : 'Not provided']);
    }
    if (!offBranch) {
      rows.push(['Off-ramp plan',       stopMap[answers.stop_plan] || 'Not provided']);
    }
    rows.push(['Holdout zones',       baLabel || 'Not provided']);
    rows.push(['Body composition',    muMap[answers.muscle] || 'Not provided']);
    rows.push(['Food noise',          answers.food_noise ? answers.food_noise + ' / 5' : 'Not provided']);
    rows.push(['Gut signals',         giLabel || (giNothing ? 'None reported' : 'Not provided')]);
    rows.push(['Med history',         medsMap[answers.meds_history] || 'Not provided']);
    rows.push(['Vegetable intake',    vegMap[answers.veggies] || 'Not provided']);
    rows.push(['Age range',           ageMap[answers.age] || 'Not provided']);
    rows.push(['Weight lost so far',  lostMap[answers.lost] || 'Not provided']);
    rows.push(['Current weight',      cw ? cw + ' lbs' : 'Not provided']);
    rows.push(['Movement',            exMap[answers.exercise] || 'Not provided']);
    rows.push(['Goal weight',         gw ? gw + ' lbs' : 'Not provided']);
    rows.push(['Regain history',      rgMap[answers.regain] || 'Not provided']);
    rows.push(['#1 priority',         goalMap[answers.goal] || 'Not provided']);

    var rowsHtml = rows.map(function (r) {
      return '<div class="dx-df-row"><span class="dx-df-k">' + esc(r[0]) + '</span><span class="dx-df-v">' + esc(r[1]) + '</span></div>';
    }).join('');

    return '' +
      '<div class="dx-datafile" id="sec-datafile">' +
        '<div class="dx-df-head">' +
          '<div>' +
            '<div class="dx-df-eyebrow">YOUR PERSONAL DATA FILE</div>' +
            '<div class="dx-df-id">Case #PV-' + caseId + '</div>' +
          '</div>' +
          '<div class="dx-df-tag">' + rows.length + ' / ' + rows.length + ' captured</div>' +
        '</div>' +
        '<div class="dx-df-grid">' + rowsHtml + '</div>' +
      '</div>';
  }

  /* Standalone inline CTA — same component used after the verdict and at
     the bottom of the process steps. Caller chooses size via `large=true`
     (adds .dx-inline-cta-lg) and the headline + meta strings. */
  function inlineCtaHtml(label, meta, large) {
    return '<div class="dx-inline-cta-wrap">' +
      '<button class="dx-inline-cta' + (large ? ' dx-inline-cta-lg' : '') + '" type="button" data-action="scroll" data-target="offer-anchor">' +
        '<span>' + esc(label) + '</span><span class="arrow">↓</span>' +
      '</button>' +
      (meta ? '<div class="dx-inline-cta-meta">' + esc(meta) + '</div>' : '') +
    '</div>';
  }

  /* Probability score · shared math used by both the verdict card and the
     gauge. Same model as the new export: sum of R+M+B scores, clamped to
     62-89% so the gauge never feels too small or maxed. */
  function computeProbability(profile) {
    var s = profile.scores || {};
    var total = (s.R || 0) + (s.M || 0) + (s.B || 0);
    return Math.max(62, Math.min(89, 60 + Math.round(total * 0.9)));
  }

  /* Verdict card · headline + recommendation + meta row. Lives ABOVE the
     data file. The gauge is rendered separately (buildGaugeHtml) so the
     two can be placed independently — gauge now sits BELOW the data file. */
  function buildVerdictHtml(profile) {
    var probability = computeProbability(profile);
    var toGo = (profile.derived && profile.derived.toGo) || 0;
    var verdictText = probability >= 80
      ? 'VERY HIGH risk of post-shot rebound without protocol support'
      : probability >= 70
        ? 'HIGH risk of post-shot rebound without protocol support'
        : 'MODERATE risk of post-shot rebound without protocol support';
    var words = verdictText.split(' ');
    var verdictBold = words.slice(0, 2).join(' ');
    var verdictRest = words.slice(2).join(' ');

    return '' +
      '<div class="dx-verdict" id="sec-verdict">' +
        '<div class="dx-verdict-eyebrow">▲ PROTOCOL VERDICT · BASED ON YOUR ANSWERS</div>' +
        '<div class="dx-verdict-headline"><strong>' + esc(verdictBold) + '</strong> ' + esc(verdictRest) + '.</div>' +
        '<div class="dx-verdict-rec">Recommended: <strong>Provitalean</strong> · the gut + metabolic protocol built to support your <strong>' + esc(profile.name) + '</strong> profile.</div>' +
        '<div class="dx-verdict-meta">' +
          '<span>Profile: <strong>' + esc(profile.name) + '</strong></span>' +
          '<span>· Probability: <strong>' + probability + '%</strong></span>' +
          (toGo > 0 ? '<span>· ' + toGo + ' lbs to your goal</span>' : '') +
        '</div>' +
      '</div>';
  }

  /* Semicircle probability gauge · sits BELOW the data file so the user
     reads their answers first, then sees the visualized risk. Path is the
     180° arc on a 200×120 viewBox; stroke-dasharray reveals probability/100
     of the arc's 251.3 total length. */
  function buildGaugeHtml(profile) {
    var probability = computeProbability(profile);
    var gaugeDashLen = (probability / 100 * 251.3).toFixed(1);
    return '' +
      '<div class="dx-gauge-wrap" id="sec-gauge">' +
        '<div class="dx-gauge-eyebrow">REBOUND PROBABILITY · WITHOUT PROTOCOL SUPPORT</div>' +
        '<div class="dx-gauge">' +
          '<svg viewBox="0 0 200 120" class="dx-gauge-svg" aria-hidden="true">' +
            '<defs><linearGradient id="dxGaugeGrad" x1="0" x2="1" y1="0" y2="0">' +
              '<stop offset="0%" stop-color="#E8B14A"/>' +
              '<stop offset="60%" stop-color="#C74827"/>' +
              '<stop offset="100%" stop-color="#9B2A12"/>' +
            '</linearGradient></defs>' +
            '<path d="M20 110 A 80 80 0 0 1 180 110" fill="none" stroke="#EFE6D6" stroke-width="14" stroke-linecap="round"/>' +
            '<path d="M20 110 A 80 80 0 0 1 180 110" fill="none" stroke="url(#dxGaugeGrad)" stroke-width="14" stroke-linecap="round"' +
              ' stroke-dasharray="' + gaugeDashLen + ' 251.3" class="dx-gauge-fill"/>' +
          '</svg>' +
          '<div class="dx-gauge-readout">' +
            '<div class="dx-gauge-num">' + probability + '<span>%</span></div>' +
            '<div class="dx-gauge-lbl">probability of rebound</div>' +
          '</div>' +
        '</div>' +
        '<div class="dx-gauge-cap">Calculated from your medication, off-ramp plan, body composition, gut signals, and regain history. Anchored to the Lancet 75.3% rebound benchmark (Mar 2026).</div>' +
      '</div>';
  }

  /* Diagnosis rows · root cause (always Gut Bacterial Burnout) plus the
     #1 downstream rebound risk picked from the highest-scored downstream
     trigger. Lives between the "Your diagnosis" intro and the trigger grid. */
  function buildDiagnosisHtml(triggers) {
    var downstream = triggers.slice(1);
    if (!downstream.length) return '';
    var dom = downstream[0];
    for (var i = 1; i < downstream.length; i++) {
      if (downstream[i].score > dom.score) dom = downstream[i];
    }
    var domHead = {
      'Hunger Switch':              'Your Personal #1 Rebound Risk Is The Hunger Switch Getting Stuck In “Feed Me” Mode.',
      'Muscle Starvation Syndrome': 'Your Personal #1 Rebound Risk Is Muscle Starvation Hollowing You Out From The Inside.',
      'Fat Cell Memory':            'Your Personal #1 Rebound Risk Is Fat Cell Memory Pulling You Back To Your Old Size.',
      'AMPK Dormancy':              'Your Personal #1 Rebound Risk Is AMPK Dormancy Locking Belly Fat In Place.',
    };
    var domWhat = {
      'Hunger Switch':              "The food noise is back, and it's loud. That tells us your satiety strains (B420 + L. rhamnosus GG) have already crashed... so your hunger off-switch is offline.",
      'Muscle Starvation Syndrome': "Your body lost weight by burning muscle along with fat. That tells us your gut isn't producing the butyrate signals that protect lean mass... which is what's showing up as the deflated, hollowed-out look.",
      'Fat Cell Memory':            'Your fat cells are pulling back toward their old size the second the shot signal fades. That tells us the cellular memory of your previous weight is still in charge... not your willpower.',
      'AMPK Dormancy':              'Your belly is holding while your arms, face and chest hollow out. That tells us your fat-burning master switch (AMPK) is dormant and your body is protecting visceral fat like a savings account.',
    };
    var domDim = {
      'Hunger Switch':              { emoji: '🍽️', label: "The Hunger Switch: Stuck in 'feed me' mode the second you taper or stop" },
      'Muscle Starvation Syndrome': { emoji: '💪', label: 'Muscle Starvation: Up to 40% of what you lost is lean mass, not fat' },
      'Fat Cell Memory':            { emoji: '🧠', label: 'Fat Cell Memory: Your cells remember their old size and pull you back to it' },
      'AMPK Dormancy':              { emoji: '🔥', label: 'AMPK Dormancy: Your fat-burning switch is asleep and belly fat is locked in' },
    };
    var dim = domDim[dom.name] || { emoji: '⚠️', label: dom.cascadeName || dom.name };
    /* Split the dim label on the first colon so the lead clause renders bold. */
    var colonIdx = dim.label.indexOf(':');
    var dimHead = colonIdx > 0 ? dim.label.slice(0, colonIdx) : dim.label;
    var dimTail = colonIdx > 0 ? dim.label.slice(colonIdx + 1) : '';
    var dimHtml = colonIdx > 0
      ? '<strong>' + esc(dimHead) + ':</strong>' + esc(dimTail)
      : esc(dim.label);

    return '' +
      '<div class="dx-diagnosis">' +
        '<div class="dx-row dx-row-root">' +
          '<div class="dx-row-label">THE MAIN REBOUND CAUSE</div>' +
          '<div class="dx-row-dim"><span class="dx-row-dim-emoji" aria-hidden="true">🦠</span><span class="dx-row-dim-text"><strong>Gut Bacterial Burnout:</strong> The four hunger-regulating bacteria your shot is starving</span></div>' +
          '<div class="dx-row-name">Gut Bacterial Burnout Is Behind The Rebound.</div>' +
          '<div class="dx-row-body">The root behind almost every shot rebound we have mapped. The keystone bacteria your body used to make its own "I\'m full" signal have starved out. This is the soil the other breakdowns grow from.</div>' +
        '</div>' +
        '<div class="dx-row dx-row-dom">' +
          '<div class="dx-row-label">YOUR #1 REBOUND RISK</div>' +
          '<div class="dx-row-dim"><span class="dx-row-dim-emoji" aria-hidden="true">' + esc(dim.emoji) + '</span><span class="dx-row-dim-text">' + dimHtml + '</span></div>' +
          '<div class="dx-row-name">' + esc(domHead[dom.name] || ('Your Personal #1 Rebound Risk Is ' + dom.name + '.')) + '</div>' +
          '<div class="dx-row-body">' + esc(domWhat[dom.name] || dom.cascadeWhy || '') + '</div>' +
        '</div>' +
      '</div>';
  }

  /* Process steps · "From checkout to first result" 4-step list, sits
     between FAQ and the final CTA. Pure static copy. */
  var PROCESS_STEPS = [
    { n: 1, name: 'Complete checkout',            time: 'About 5 minutes',     detail: 'One-time purchase. No auto-billing. Your quiz answers are saved with your order so the bottles match the profile this readout matched you to.' },
    { n: 2, name: 'Order confirmed and packed',   time: 'Under 24 hours',      detail: 'Confirmation email arrives within minutes. Bottles ship from a U.S. facility same business day or next, with tracking.' },
    { n: 3, name: 'Bottles arrive at your door',  time: '2 to 5 business days', detail: 'Free U.S. shipping on every order. Inside the box: your bottles, the protocol guide, and your day-one instructions.' },
    { n: 4, name: 'First noticeable shift',       time: 'Week 1',              detail: 'Two capsules with breakfast. Most women report digestion easing by day 5. The food noise begins softening by week 2. Full results window is 60 to 90 days.' },
  ];
  function buildProcessStepsHtml() {
    var items = PROCESS_STEPS.map(function (s) {
      return '<li class="dx-process-step">' +
        '<div class="dxp-num">' + s.n + '</div>' +
        '<div class="dxp-body">' +
          '<div class="dxp-name">' + esc(s.name) + '</div>' +
          '<time class="dxp-time">' + esc(s.time) + '</time>' +
          '<div class="dxp-detail">' + esc(s.detail) + '</div>' +
        '</div>' +
      '</li>';
    }).join('');
    return '' +
      '<div class="dx-process" id="sec-process">' +
        '<div class="dx-process-eyebrow">FROM CHECKOUT TO FIRST RESULT</div>' +
        '<h2 class="dx-process-h">What happens after you <em>activate your protocol.</em></h2>' +
        '<ol class="dx-process-list">' + items + '</ol>' +
        inlineCtaHtml('See my personalized protocol', '90-day money-back · free U.S. shipping · ships from the U.S.', true) +
      '</div>';
  }

  function computeTriggers(answers) {
    var fn = Number(answers.food_noise) || 0;
    var dur = answers.duration;
    var durScore = dur === 'gt12' ? 4 : dur === '6to12' ? 3 : dur === '3to6' ? 2 : dur === 'past' ? 4 : 1;
    var muMap = { strong: 1, looser: 2, deflated: 3, elephant: 4, weaker: 5 };
    var ageMap = { '25-34': 1, '35-44': 2, '45-54': 3, '55-64': 4, '65+': 5 };
    var lostMap = { '<15': 1, '15-30': 2, '30-50': 3, '50+': 4 };
    var rgMap = { first: 1, some: 2, all: 3, worse: 4 };
    var spMap = { 'taper-now': 4, soon: 4, undecided: 3, staying: 1, 'already-off': 5 };

    /* Belly distribution is now a chips multi-select. Each indicative chip
       contributes; sum is clamped at the old single-radio max. */
    var ba = Array.isArray(answers.body_areas) ? answers.body_areas : [];
    var bfScore = (ba.indexOf('stomach')    !== -1 ? 4 : 0) +
                  (ba.indexOf('hipsthighs') !== -1 ? 1 : 0) +
                  (ba.indexOf('whole')      !== -1 ? 2 : 0) || 1;

    /* GI signal is also a chips multi-select. More symptoms = more disruption. */
    var gi = Array.isArray(answers.gi_symptoms) ? answers.gi_symptoms : [];
    var giCount = 0;
    for (var i = 0; i < gi.length; i++) {
      if (gi[i] !== 'nothing') giCount++;
    }
    var dgScore = giCount === 0 ? 1 : Math.min(4, 1 + giCount);

    var akkermansia    = 35 + durScore * 12 + (spMap[answers.stop_plan] || 1) * 4 + fn * 3;
    var satietyStrains = 30 + fn * 9 + durScore * 6 + (rgMap[answers.regain] || 1) * 4;
    var muscleLoss     = 25 + (muMap[answers.muscle] || 1) * 10 + (lostMap[answers.lost] || 1) * 6 + (ageMap[answers.age] || 1) * 3;
    var fatCellMemory  = 25 + (rgMap[answers.regain] || 1) * 12 + bfScore * 6 + (lostMap[answers.lost] || 1) * 4;
    var bellyLockIn    = 30 + bfScore * 10 + (ageMap[answers.age] || 1) * 4 + dgScore * 3;

    return [
      { name: 'Gut Bacterial Burnout',      score: Math.min(94, akkermansia),     stat: 'Drops 70%+ in chronic shot users',
        art: IMG.trigger_gut_burnout,
        cascadeName: 'Akkermansia starves',
        cascadeWhy: 'Slowed digestion shuts off the keystone bacteria that produces your body’s natural ‘I’m full’ signal.',
        punch: 'Your built-in off-switch crashes with it.',
        what: 'Slowed digestion starves **Akkermansia muciniphila**... the keystone bacteria that naturally produces your body\'s own satiety signal and tells you "I\'m full."',
        fix: 'B. lactis B420™ helps **rebuild Akkermansia naturally**, so your body keeps producing its own satiety signal even off the shot.' },
      { name: 'Hunger Switch',              score: Math.min(94, satietyStrains),  stat: 'B420 + L. rhamnosus deplete first',
        art: IMG.trigger_hunger_switch,
        cascadeName: 'Satiety strains crash',
        cascadeWhy: 'B. lactis B420 and L. rhamnosus GG die off next. Food noise floods back. Not gradually... all at once.',
        punch: 'Food noise comes back. Not gradually... all at once.',
        what: '**B. lactis B420 and L. rhamnosus GG** (the "satiety strains") deplete first under chronic shot use. When they go, the satiety signal goes with them. Like a switch.',
        fix: 'Clinical doses of **B420 + L. rhamnosus GG** to recolonize the satiety strains and quiet the food noise from the inside.' },
      { name: 'Muscle Starvation Syndrome', score: Math.min(94, muscleLoss),      stat: 'Up to 40% of loss is lean mass',
        art: IMG.trigger_muscle_starvation,
        cascadeName: 'Body burns muscle for fuel',
        cascadeWhy: 'Without microbiome support, the body can’t tell fat from muscle. Up to 40% of weight lost is lean mass.',
        punch: 'Up to 40% of what you lose is muscle, not fat.',
        what: 'Without microbiome support, your body can\'t tell fat from muscle and burns both. The source of "**pancake butt, bat-wing arms, shot-face**."',
        fix: '**B420 + Chromium** support stable blood sugar so your body uses fat for fuel, not muscle.' },
      { name: 'Fat Cell Memory',            score: Math.min(94, fatCellMemory),   stat: 'Hinte 2024 · Nature',
        art: IMG.trigger_fat_cell_memory,
        cascadeName: 'Fat cells lock in memory',
        cascadeWhy: 'Adipose tissue keeps an epigenetic memory of obesity... primed to refill the moment satiety signals fade.',
        punch: "It's not willpower. It's bacterial.",
        what: 'Hinte 2024 (Nature) proved your adipose tissue keeps an **epigenetic memory of obesity**... primed to refill the moment satiety signals fade. This is why every diet "rebounds" at the same weight.',
        fix: '**Morosil® Red Orange + Hibiscus** help reset the cell environment so the memory loosens its grip.' },
      { name: 'AMPK Dormancy',              score: Math.min(94, bellyLockIn),     stat: 'Visceral fat = metabolically different',
        art: IMG.trigger_ampk_dormancy,
        cascadeName: 'Fat-burning switch dims',
        cascadeWhy: 'AMPK downshifts. Visceral abdominal fat sits there protected while arms and face hollow out.',
        punch: 'Abdominal fat protected. Arms and face hollow out.',
        what: 'AMPK (your fat-burning master switch) downshifts during rapid weight loss. Visceral abdominal fat sits there protected... exactly the **skinny-fat pattern**.',
        fix: '**Morosil® supports AMPK reactivation.** 2.5cm waist reduction in 12 weeks (clinical).' },
    ];
  }

  /* ============== TIMELINE / FAILURES / TESTIMONIALS / INGREDIENTS / FAQ ============== */
  /* SVG icons used on the 90-day timeline. The React reference inlines these
     as JSX; we inline them as raw markup here. */
  var TL_ICONS = {
    spark:  '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true"><path d="M12 0.5 L13.7 9.4 L22.5 11.5 L13.7 13.6 L12 22.5 L10.3 13.6 L1.5 11.5 L10.3 9.4 Z"/></svg>',
    wave:   '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M3 7 Q7.5 3 12 7 T21 7"/><path d="M3 13 Q7.5 10 12 13 T21 13" opacity="0.7"/><path d="M3 19 Q7.5 17 12 19 T21 19" opacity="0.4"/></svg>',
    shield: '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true"><path d="M12 1.2 L20.5 4.2 V11.5 C20.5 17 15.6 21 12 22.8 C8.4 21 3.5 17 3.5 11.5 V4.2 Z"/><path d="M8.4 12.2 L11 14.6 L15.8 9.6" stroke="#fff" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    crown:  '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true"><path d="M3.5 8 L7 13 L12 5 L17 13 L20.5 8 L19 19.2 H5 Z"/><circle cx="3.5" cy="8" r="1.5"/><circle cx="20.5" cy="8" r="1.5"/><circle cx="12" cy="5" r="1.6"/></svg>',
  };

  function getTimeline() {
    return [
      { week: 'WEEK 1–2', phase: 'The First Spark', icon: TL_ICONS.spark,  detail: "Food chatter starts to quiet. Late-night cravings get less intense. Digestion feels smoother, lighter. You notice... quietly... that you forgot to think about lunch." },
      { week: 'WEEK 3–4', phase: 'Real Relief',     icon: TL_ICONS.wave,   detail: "The food noise that felt deafening is now background. Afternoon sugar crashes fade. Bloating eases. Clothes fit a little looser even when the scale hasn't moved much." },
      { week: 'WEEK 5–8', phase: 'Lasting Control', icon: TL_ICONS.shield, detail: 'Your body is adapting to its new normal, with the bacteria that regulate hunger and fat-burning rebuilt. Cravings stay quiet. Weight loss feels steady. You feel in control instead of controlled by food.' },
      { week: '90 DAYS+',      phase: 'You Own It',       icon: TL_ICONS.crown,  detail: 'With continued use, Provitalean keeps your results stable even if you reduce or stop the shot. Rebound risk drops. Food noise stays silent. You stop renting your body and start owning it.' },
    ];
  }

  var FAILURES = [
    { n: 'Celebrity-backed GLP-1 gummies muffle one signal... and leave four breakdowns running.',
      w: "They're cute, but they only touch hunger. They don't have the bacteria the shot actually wipes out, so the real problem keeps running in the background." },
    { n: 'Store-shelf probiotics support digestion... and ignore the strains the weekly injection depletes.',
      w: "Drugstore probiotics are made for general bloating. They don't have the specific strains the shot kills off... it's like throwing the wrong key at the lock." },
    { n: '$215/month single-strain Akkermansia caps cover one pillar of a five-pillar problem.',
      w: "$215 a month for one bacteria. It's the right one, but it's only one of five things that broke. You're plugging one hole in a boat leaking in five places." },
    { n: "Protein powder + creatine feed muscle... but can't quiet food noise or restart Akkermansia.",
      w: "It builds muscle if you eat it... but the food noise is still screaming, and the bacteria that tells your brain 'you're full' is still missing. You're working out around the actual problem." },
    { n: 'Stopping the shot without gut support: 75% of loss reverses past 52 weeks.',
      w: 'Lancet just published it (March 2026): three out of every four pounds you lost come back in the year after you stop. The bacteria the shot starved are still gone, so your body has nothing to hand the job off to.' },
  ];

  var INGREDIENTS = [
    { key: 'morosil',   img: IMG.ig_morosil,   name: 'Morosil® Moro Red Orange',  dose: '400 mg per day · standardized extract', claim: 'Supported a 2.5 cm waist circumference reduction and 5% abdominal-fat reduction in 12 weeks (Cardile et al., 2015).', why: 'Helps reactivate AMPK (your fat-burning master switch) and may target visceral abdominal fat. The ingredient your abdomen is missing.', benefits: ['May support a smaller waist measurement', 'Targets visceral abdominal fat', 'Helps reactivate the fat-burning switch'] },
    { key: 'b420',      img: IMG.ig_b420,      name: 'B. lactis B420™ Probiotic',  dose: '10 billion CFU per day',                  claim: 'Up to 4% body-fat reduction in a 6-month, double-blind, placebo-controlled trial (Stenman et al., EBioMedicine 2016, n=225).', why: 'The most-studied "satiety strain" for women on the shot. Helps rebuild Akkermansia naturally and supports lean-mass retention during weight loss.', benefits: ['Less bloating, smoother digestion', 'Supports lean-mass retention', 'Helps rebuild Akkermansia naturally'] },
    { key: 'rhamnosus', img: IMG.ig_rhamnosus, name: 'L. rhamnosus GG',                 dose: '5 billion CFU per day',                   claim: 'The most clinically studied probiotic strain in the world. Sanchez 2014 (24-week): women lost 5.2 kg vs. 3.6 kg placebo... roughly 2× the loss.', why: "Supports the gut's natural appetite regulation. Works on the shot. Helps hold the line when you taper off.", benefits: ['Supports a quieter appetite signal', 'Less afternoon snacking', 'Steady mood + cravings'] },
    { key: 'lactis',    img: IMG.ig_lactis,    name: 'L. lactis LI-23',                 dose: '5 billion CFU per day',                   claim: 'Co-cultured satiety strain that supports Akkermansia colonization and short-chain fatty-acid production.', why: 'Pairs with B420 to help rebuild the keystone bacteria the shot depleted. Synbiotic effect = faster recolonization.', benefits: ['Supports Akkermansia rebuild', 'Better short-chain fatty acids', 'Supports a healthier gut barrier'] },
    { key: 'chromium',  img: IMG.ig_chromium,  name: 'Chromium Picolinate',             dose: '200 mcg per day · 571% DV',           claim: '21 published human studies. Anton 2008 significantly reduced carbohydrate and fat cravings; supports healthy blood-sugar response.', why: 'Helps reduce the late-afternoon sugar crash that pulls you toward processed carbs. The piece every probiotic-only formula misses.', benefits: ['May help reduce carb cravings', 'Supports steadier energy', 'Supports stable post-meal blood sugar'] },
    { key: 'hibiscus',  img: IMG.ig_hibiscus,  name: 'Hibiscus Sabdariffa Extract',     dose: '400 mg per day',                          claim: 'Chang 2014, 12-week trial: supported reductions in body weight, body fat, and waist-to-hip ratio.', why: 'May support healthy carb metabolism so your gut bacteria have a calmer environment to recolonize in.', benefits: ['Less post-meal bloat', 'Supports cardiometabolic health', 'Gentle, plant-based fat support'] },
  ];

  /* Verified Provitalean customer reviews. Photos are local (uploaded to
     Shopify Files with the un- prefix); the reviewer copy is unchanged from
     rejuveen.com. Falls back to CDN imagery if a local file is missing so a
     pre-Phase-4 deploy doesn't render a broken image. */
  function getTestimonials() {
    return [
      { img: IMG.rev_christen_p || IMG.story_christen, headline: 'Better sleep, less bloating, inches off my waist.',
        quote: "LOVE this product!!! I love the energy I have since using this product!!! It has helped tremendously with appetite control, and helping me get a better night's sleep!!! After taking it for 30 days I have less bloating and I have already lost a few inches in my waist!",
        name: 'Christen P.', detail: '30 days in · Verified Customer', badge: '−11 lbs' },
      { img: IMG.rev_theresa_m || IMG.story_natty, headline: "Finally lost the pounds that wouldn't budge.",
        quote: "I noticed my reduced cravings right away... which led to me finally losing the 6 lbs I've been struggling to lose for almost a year!! I feel that it definitely helped to change my eating habits. I've also had more energy and become more 'regular' as well!",
        name: 'Theresa M.', detail: 'Verified Customer · rejuveen.com', badge: '−6 lbs' },
      { img: IMG.rev_laurie_d || IMG.story_jenny, headline: 'My appetite is suppressed. I feel lighter.',
        quote: "I definitely feel that my appetite is suppressed. I don't seem to have cravings specifically for sweet things. I also feel lighter with less bloating.",
        name: 'Laurie D.', detail: 'Verified Customer · rejuveen.com', badge: 'Less bloat' },
    ];
  }

  var FAQ_ITEMS = [
    { q: 'Should I take Provitalean WITH or AFTER my shot?',
      a: "The truth is... both. ON the shot: Provitalean helps support your gut bacteria against Gut Bacterial Burnout, so you may see steadier loss, fewer side effects like nausea and constipation, and quieter cravings while the medication does its work. AFTER the shot: Provitalean helps keep your Akkermansia levels strong, so your appetite stays quiet and the weight you fought to lose doesn't come storming back. Women who succeed long-term use it on the shot to support steadier results, and afterwards to help protect them." },
    { q: 'How long before I notice the food noise quieting down?',
      a: "Most women notice the first spark inside 14 days... the constant food chatter starts to quiet, late-night cravings get less intense, digestion feels smoother. By week 4, real relief sets in: afternoon sugar crashes fade, bloating eases, clothes start fitting looser. Lasting control (what we call \"You Own It\") kicks in around 90 days when Akkermansia and the satiety strains are fully recolonized." },
    { q: "Will Provitalean help if I'm not on the shot?",
      a: 'Yes. While Provitalean was designed to support women on the shot through Gut Bacterial Burnout, overweight adults typically have lower levels of Akkermansia muciniphila... the keystone bacteria that helps regulate appetite and fat storage. By helping rebuild Akkermansia naturally and layering in Morosil, Hibiscus, and Chromium, Provitalean may help quiet food noise, ease cravings, and support steady fat loss with or without a weekly injection.' },
    { q: 'Is Provitalean safe to take alongside the weekly injection?',
      a: "There are no known interactions between Provitalean and any weekly injection protocol, including semaglutide, tirzepatide, or compounded versions. Provitalean is third-party tested for purity at NSF and GMP certified facilities. We always recommend mentioning any new supplement to the prescriber managing your treatment, especially if you've had recent dose changes." },
    { q: 'What happens if I stop the shot but keep taking Provitalean?',
      a: 'This is exactly where Provitalean shines. Many women who quit the shot see the weight return within 12 months because their gut bacteria have collapsed... particularly Akkermansia. Provitalean helps rebuild those bacteria so when you step off, your appetite stays quiet, cravings stay supported, and your results have a better chance of sticking. Think of it as your off-ramp insurance against rebound weight gain.' },
    { q: 'What makes Provitalean different from probiotics I can buy at the store?',
      a: "Store probiotics are one-dimensional... they support digestion but don't address Gut Bacterial Burnout. Provitalean is a complete system: it helps rebuild Akkermansia muciniphila naturally to support hunger and fat-storage regulation, uses Morosil® Red Orange to help reactivate AMPK (the body's fat-burning switch), Hibiscus to support healthy carb metabolism, and Chromium at 571% DV to help reduce carb cravings. Customers describe it as the difference between owning your metabolism and just renting it." },
    { q: "Why hasn't my doctor mentioned Gut Bacterial Burnout?",
      a: "Because there's no patent on it. Akkermansia muciniphila was discovered in 2004 and has been heavily studied for supporting weight regulation and reducing rebound risk. But Akkermansia is a natural microorganism... it can't be patented. If big pharma can't patent it, they have no incentive to talk about it, and most prescribers were never trained on the gut-microbiome side of the equation. Provitalean exists to fill that gap so your prescription can actually do its job long-term." },
    { q: "What if it doesn't work for me?",
      a: "We stand behind the science with our 90-Day Satisfaction Promise. If you don't experience quieter food noise, easier digestion, or steadier weight inside 90 days, contact us at support@rejuveen.com for a full refund... no questions asked. You can keep any unopened bottles. There's no auto-billing and no subscription trap. You stay in control." },
    { q: "Will it work if I'm not exercising or eating perfectly?",
      a: 'Like any high-quality supplement, Provitalean is designed to support your weight-loss journey and works best with moderate exercise, balanced eating, and decent sleep. Unlike products that promise outrageous results, we believe in under-promising and over-delivering. You may see positive results from Provitalean alone, and your best results when paired with simple habits like regular movement, balanced eating, and restful sleep.' },
    { q: 'Can I take this with HRT, blood thinners, or other medications?',
      a: "Provitalean is formulated to be gentle and complement most regimens. That said, if you're taking prescription medications (particularly blood thinners, thyroid medication, hormone replacement therapy, or antibiotics) we recommend consulting your healthcare provider first. Your doctor knows your complete health picture and can confirm there are no contraindications specific to your situation." },
    { q: "What's the recommended dose and timing?",
      a: "Take 2 capsules daily with a meal (preferably breakfast or lunch) and a full glass of water. Consistency matters more than timing, so pick a time you'll remember and stick with it. Give it the full 60 to 90 days. Akkermansia and the satiety strains take time to recolonize. You're rebuilding your microbiome from the cellular level up." },
    { q: 'Does Provitalean contain any allergens or animal products?',
      a: 'Provitalean is free from common allergens including milk, eggs, fish, shellfish, tree nuts, peanuts, wheat, soybeans, and sesame. All ingredients are non-GMO and gluten-free. The capsules are vegetarian. Always review the supplement facts label if you have a specific allergy.' },
  ];

  /* ============== RESULTS STAGE HELPERS ============== */

  function buildResultsProgressHtml(stage) {
    var step = STAGE_TO_STEP[stage - 1] || 1;  /* visual bar fill (1–RESULT_STEP_COUNT) */
    var segsHtml = '';
    for (var i = 0; i < RESULT_STEP_COUNT; i++) {
      var cls = 'rp-seg' + (i < step ? ' done' : '') + (i === step - 1 ? ' current' : '');
      segsHtml += '<span class="' + cls + '"></span>';
    }
    /* Labels and meta text use stage directly so Ingredients/Reviews/Plan each
       highlight their own label rather than inheriting Protocol's step index. */
    var labelsHtml = RESULT_STAGE_LABELS.map(function (l, i) {
      var cls = 'rp-ml' + (i === stage - 1 ? ' current' : i < stage - 1 ? ' done' : '');
      return '<span class="' + cls + '">' + esc(l) + '</span>';
    }).join('');
    var currentLabel = RESULT_STAGE_LABELS[stage - 1] || '';
    return '<div class="results-progress" aria-label="Step ' + step + ' of ' + RESULT_STEP_COUNT + '">' +
      '<div class="rp-track">' + segsHtml + '</div>' +
      '<div class="rp-meta">' +
        '<span class="rp-step">Step ' + step + ' of ' + RESULT_STEP_COUNT + '</span>' +
        '<span class="rp-label">' + esc(currentLabel) + '</span>' +
      '</div>' +
      '<div class="rp-microlabels" aria-hidden="true">' + labelsHtml + '</div>' +
    '</div>';
  }

  function buildStageNavHtml(label, stage) {
    var continueLabel = label || 'Continue';
    var showBack = stage > 1 && stage < RESULT_STAGE_COUNT;
    return '<div class="results-continue-wrap">' +
      '<button type="button" class="btn-primary results-continue" data-action="result-next">' + esc(continueLabel) + ' <span class="arrow">→</span></button>' +
      (showBack ? '<button type="button" class="results-back" data-action="result-back">← Go back</button>' : '') +
    '</div>';
  }

  function buildStageStickyCtaHtml(label) {
    return '<div class="stage-sticky-cta" id="stage-sticky-cta" style="display:none">' +
      '<button type="button" class="btn-primary" data-action="result-next">' + esc(label || 'Continue') + ' <span class="arrow">→</span></button>' +
    '</div>';
  }

  /* Personal-bullets list (reused in stage 1 hero and stage 2 diagnosis). */
  function buildPersonalBulletsHtml(profile) {
    if (!profile.personalBullets.length) return '';
    return '<ul class="personal-bullets">' + profile.personalBullets.map(function (b) {
      return '<li><span class="pb-check">✓</span><span class="pb-text"><span class="pb-label">' + esc(b.label) + '</span>' + (b.tag ? '<span class="pb-tag"> · ' + esc(b.tag) + '</span>' : '') + '</span></li>';
    }).join('') + '</ul>';
  }

  /* Trigger cards grid (shared between stage 2 diagnosis). */
  function buildTriggerCardsHtml(triggers) {
    return triggers.map(function (t, i) {
      var risk = t.score >= 75 ? 'risk-critical' : t.score >= 60 ? 'risk-high' : t.score >= 45 ? 'risk-mod' : 'risk-low';
      var riskLabel = t.score >= 75 ? 'CRITICAL' : t.score >= 60 ? 'HIGH' : t.score >= 45 ? 'MODERATE' : 'LOW';
      var fillBg = t.score >= 70 ? 'var(--orange)' : 'var(--orange-soft)';
      var pctClass = 'trigger-pct' + (t.score >= 70 ? ' is-high' : '');
      var artInlineHtml = t.art ? '<div class="trigger-art trigger-art-inline" aria-hidden="true">' + imgTag(t.art, '') + '</div>' : '';
      return '<button type="button" class="trigger-card flip" data-trigger-card="' + i + '" aria-pressed="false" aria-label="' + esc(Math.round(t.score) + ' percent risk. ' + t.name + ': ' + t.cascadeName + '. ' + t.cascadeWhy + '. Tap for details.') + '">' +
        '<div class="flip-inner">' +
        '<div class="flip-face flip-front">' +
        '<div class="front-top">' +
        '<div class="mech-label">' + esc(t.name) + '</div>' +
        '<div class="risk-pill ' + risk + '">' + riskLabel + '</div>' +
        '</div>' +
        '<div class="trigger-head-row">' + artInlineHtml + '<div class="trigger-headline">' + esc(t.cascadeName) + '.</div></div>' +
        '<div class="trigger-why">' + esc(t.cascadeWhy) + '</div>' +
        '<div class="trigger-score-row"><span class="trigger-score-lbl">Your risk</span><span class="' + pctClass + '">' + Math.round(t.score) + '%</span></div>' +
        '<div class="bar"><div class="bar-fill" style="width:' + t.score + '%;animation-delay:' + (i * 120) + 'ms;background:' + fillBg + '"></div></div>' +
        '<div class="front-foot"><span class="stat-line">' + esc(t.stat) + '</span><span class="flip-cue">Tap →</span></div>' +
        '</div>' +
        '<div class="flip-face flip-back">' +
        '<div class="back-name">' + esc(t.name) + '</div>' +
        (t.punch ? '<div class="back-punch-wrap"><span class="back-punch">' + esc(t.punch) + '</span></div>' : '') +
        '<div class="back-what">' + renderRich(t.what) + '</div>' +
        '<div class="back-fix"><strong class="protocol-label">Your protocol:</strong> ' + renderRich(t.fix) + '</div>' +
        '<div class="flip-cue back-cue">Tap to flip back</div>' +
        '</div>' +
        '</div></button>';
    }).join('');
  }

  /* DX forecast graph SVG for stage 6. */
  function buildDxGraphHtml(cw, gw, probabilityAll) {
    if (!cw || !gw || cw <= gw) return '';
    var toGo = cw - gw;
    var W = 720, H = 380, padL = 50, padR = 30, padT = 70, padB = 56;
    var innerW = W - padL - padR, innerH = H - padT - padB;
    var baseline = padT + innerH;
    var reboundPeak = cw + Math.max(8, Math.round(toGo * 0.25));
    var yMin = Math.max(0, gw - 14), yMax = reboundPeak + 6;
    var yScale = function (val) { return padT + innerH - (val - yMin) / (yMax - yMin || 1) * innerH; };
    var xScale = function (m) { return padL + m / 12 * innerW; };
    var STEPS_N = 49;
    var protoPts = [], rebPts = [];
    for (var i = 0; i < STEPS_N; i++) {
      var m = i * 12 / (STEPS_N - 1);
      var t = Math.min(1, m / 6), ease = 1 - Math.pow(1 - t, 2);
      protoPts.push({ m: m, y: cw - (cw - gw) * ease });
      var yVal;
      if (m <= 4) { var t2 = m / 4; yVal = cw - (cw - gw) * (1 - Math.pow(1 - t2, 2)); }
      else { var t3 = (m - 4) / 8; yVal = gw + (reboundPeak - gw) * (1 - Math.pow(1 - t3, 1.4)); }
      rebPts.push({ m: m, y: yVal });
    }
    var toPath = function (pts) {
      return pts.map(function (p, j) { return (j === 0 ? 'M' : 'L') + xScale(p.m).toFixed(1) + ',' + yScale(p.y).toFixed(1); }).join(' ');
    };
    var protoPath = toPath(protoPts), rebPath = toPath(rebPts);
    var areaPath = protoPath + ' L' + xScale(12).toFixed(1) + ',' + baseline + ' L' + xScale(0).toFixed(1) + ',' + baseline + ' Z';
    var xStart = xScale(0), yStart = yScale(cw), xEnd = xScale(12);
    var yProtoEnd = yScale(gw), yReboundEnd = yScale(reboundPeak);
    var xStop = xScale(4), yTodayTop = padT - 14;

    var pill2W = function (eye, val) { return Math.max(168, Math.max(eye.length * 7.5, val.length * 14) + 28); };
    var stopW = pill2W('SHOT STOPPED', 'MONTH 4');
    var stopX = Math.min(W - padR - stopW / 2 - 4, Math.max(padL + stopW / 2 + 4, xStop));
    var pyStop = yTodayTop + 64;

    var startTxt = cw + ' LBS', goalTxt = gw + ' LBS', peakTxt = reboundPeak + ' LBS';

    /* ON THE SHOT pill */
    var onShotW = pill2W('ON THE SHOT', startTxt);
    var minX = padL + 4;
    var stopLeft2 = xStop - stopW / 2, maxRight = stopLeft2 - 14;
    var onCx = Math.max(minX + onShotW / 2, xStart);
    if (onCx + onShotW / 2 > maxRight) onCx = maxRight - onShotW / 2;
    if (onCx - onShotW / 2 < minX) onCx = minX + onShotW / 2;

    /* WITHOUT PROTOCOL pill */
    var woPW = pill2W('WITHOUT PROTOCOL', peakTxt);
    var maxX = W - padR - 4;
    var woCx = xEnd - woPW / 2 - 18;
    if (woCx - woPW / 2 < minX) woCx = minX + woPW / 2;
    if (woCx + woPW / 2 > maxX) woCx = maxX - woPW / 2;
    var woPy = yReboundEnd - 26;

    /* WITH PROTOCOL pill */
    var wpW = pill2W('WITH PROTOCOL', goalTxt);
    var wpCx = xEnd - wpW / 2 - 18;
    if (wpCx - wpW / 2 < minX) wpCx = minX + wpW / 2;
    if (wpCx + wpW / 2 > maxX) wpCx = maxX - wpW / 2;
    var wpPy = yProtoEnd - 26;

    /* Month axis labels */
    var monthLabels = '';
    [0, 3, 6, 9, 12].forEach(function (mo) {
      if (mo === 0) monthLabels += '<text x="' + xScale(mo) + '" y="' + (H - 18) + '" text-anchor="start" font-size="16" fill="#8A7F75" font-family="JetBrains Mono, monospace" font-weight="600">TODAY</text>';
      else if (mo === 12) monthLabels += '<text x="' + xScale(mo) + '" y="' + (H - 18) + '" text-anchor="end" font-size="16" fill="#8A7F75" font-family="JetBrains Mono, monospace" font-weight="600">MONTH 12</text>';
      else monthLabels += '<text x="' + xScale(mo) + '" y="' + (H - 18) + '" text-anchor="middle" font-size="13" fill="#B0A695" font-family="JetBrains Mono, monospace">M' + mo + '</text>';
    });

    var gridLines = [0, 3, 6, 9, 12].map(function (mo) {
      return '<line x1="' + xScale(mo) + '" x2="' + xScale(mo) + '" y1="' + padT + '" y2="' + baseline + '" stroke="#EFE6D6" stroke-width="1"/>';
    }).join('');

    return '<div class="dx-graph" id="sec-graph">' +
      '<div class="dx-graph-eyebrow">YOUR 12-MONTH FORECAST</div>' +
      '<div class="dx-graph-h">Based on your <em>quiz answers</em>.</div>' +
      '<div class="dx-graph-svg-wrap">' +
        '<svg viewBox="0 0 ' + W + ' ' + H + '" class="dx-graph-svg" preserveAspectRatio="xMidYMid meet">' +
          '<defs>' +
            '<linearGradient id="dxAreaGrad" x1="0" x2="0" y1="0" y2="1">' +
              '<stop offset="0%" stop-color="#3F7A4F" stop-opacity="0.22"/>' +
              '<stop offset="100%" stop-color="#3F7A4F" stop-opacity="0"/>' +
            '</linearGradient>' +
            '<filter id="dxPillShadow" x="-10%" y="-10%" width="120%" height="140%">' +
              '<feDropShadow dx="0" dy="2" stdDeviation="2.5" flood-color="#1E1A15" flood-opacity="0.18"/>' +
            '</filter>' +
          '</defs>' +
          gridLines +
          '<line x1="' + padL + '" x2="' + (W - padR) + '" y1="' + yStart + '" y2="' + yStart + '" stroke="#D8C9A8" stroke-width="1.2" stroke-dasharray="4 5"/>' +
          '<line x1="' + padL + '" x2="' + (W - padR) + '" y1="' + yProtoEnd + '" y2="' + yProtoEnd + '" stroke="#C8B891" stroke-width="1.2" stroke-dasharray="4 5"/>' +
          '<path d="' + areaPath + '" fill="url(#dxAreaGrad)" class="dx-area-fill"/>' +
          '<path d="' + rebPath + '" fill="none" stroke="#C74827" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round" pathLength="1" class="dx-line dx-line-red"/>' +
          '<path d="' + protoPath + '" fill="none" stroke="#3F7A4F" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round" pathLength="1" class="dx-line dx-line-green"/>' +
          monthLabels +
          /* SHOT STOPPED pill */
          '<g class="dx-event">' +
            '<line x1="' + xStop + '" x2="' + xStop + '" y1="' + (pyStop + 56) + '" y2="' + baseline + '" stroke="#3D6EA5" stroke-width="1.5" stroke-dasharray="5 5" class="dx-event-line"/>' +
            '<g class="dx-pill dx-pill-stop" filter="url(#dxPillShadow)">' +
              '<rect x="' + (stopX - stopW / 2) + '" y="' + pyStop + '" width="' + stopW + '" height="52" rx="12" fill="#3D6EA5"/>' +
              '<text x="' + stopX + '" y="' + (pyStop + 19) + '" text-anchor="middle" fill="#D7E5F5" font-size="11" font-weight="700" font-family="JetBrains Mono, monospace" letter-spacing="0.12em">SHOT STOPPED</text>' +
              '<text x="' + stopX + '" y="' + (pyStop + 41) + '" text-anchor="middle" fill="#FFFFFF" font-size="20" font-weight="700" font-family="Inter Tight, sans-serif">MONTH 4</text>' +
            '</g>' +
          '</g>' +
          /* ON THE SHOT pill */
          '<g class="dx-pill dx-pill-1" filter="url(#dxPillShadow)">' +
            '<rect x="' + (onCx - onShotW / 2) + '" y="' + yTodayTop + '" width="' + onShotW + '" height="52" rx="12" fill="#1E1A15"/>' +
            '<text x="' + onCx + '" y="' + (yTodayTop + 19) + '" text-anchor="middle" fill="#C8B891" font-size="11" font-weight="700" font-family="JetBrains Mono, monospace" letter-spacing="0.12em">ON THE SHOT</text>' +
            '<text x="' + onCx + '" y="' + (yTodayTop + 41) + '" text-anchor="middle" fill="#FFF6E5" font-size="20" font-weight="700" font-family="Inter Tight, sans-serif">' + startTxt + '</text>' +
            '<line x1="' + xStart + '" y1="' + (yTodayTop + 52) + '" x2="' + xStart + '" y2="' + (yStart - 8) + '" stroke="#1E1A15" stroke-width="2"/>' +
            '<circle cx="' + xStart + '" cy="' + yStart + '" r="7" fill="#1E1A15"/>' +
          '</g>' +
          /* WITHOUT PROTOCOL pill */
          '<g class="dx-pill dx-pill-3" filter="url(#dxPillShadow)">' +
            '<rect x="' + (woCx - woPW / 2) + '" y="' + woPy + '" width="' + woPW + '" height="52" rx="12" fill="#C74827"/>' +
            '<text x="' + woCx + '" y="' + (woPy + 19) + '" text-anchor="middle" fill="#FBE3D7" font-size="11" font-weight="700" font-family="JetBrains Mono, monospace" letter-spacing="0.12em">WITHOUT PROTOCOL</text>' +
            '<text x="' + woCx + '" y="' + (woPy + 41) + '" text-anchor="middle" fill="#FFFFFF" font-size="20" font-weight="700" font-family="Inter Tight, sans-serif">' + peakTxt + '</text>' +
            '<line x1="' + (woCx + woPW / 2) + '" y1="' + (woPy + 26) + '" x2="' + (xEnd - 8) + '" y2="' + yReboundEnd + '" stroke="#C74827" stroke-width="2"/>' +
            '<circle cx="' + xEnd + '" cy="' + yReboundEnd + '" r="7" fill="#C74827" stroke="#FFF" stroke-width="2"/>' +
          '</g>' +
          /* WITH PROTOCOL pill */
          '<g class="dx-pill dx-pill-2" filter="url(#dxPillShadow)">' +
            '<rect x="' + (wpCx - wpW / 2) + '" y="' + wpPy + '" width="' + wpW + '" height="52" rx="12" fill="#3F7A4F"/>' +
            '<text x="' + wpCx + '" y="' + (wpPy + 19) + '" text-anchor="middle" fill="#D7E8DC" font-size="11" font-weight="700" font-family="JetBrains Mono, monospace" letter-spacing="0.12em">WITH PROTOCOL</text>' +
            '<text x="' + wpCx + '" y="' + (wpPy + 41) + '" text-anchor="middle" fill="#FFFFFF" font-size="20" font-weight="700" font-family="Inter Tight, sans-serif">' + goalTxt + '</text>' +
            '<line x1="' + (wpCx + wpW / 2) + '" y1="' + (wpPy + 26) + '" x2="' + (xEnd - 8) + '" y2="' + yProtoEnd + '" stroke="#3F7A4F" stroke-width="2"/>' +
            '<circle cx="' + xEnd + '" cy="' + yProtoEnd + '" r="7" fill="#3F7A4F" stroke="#FFF" stroke-width="2"/>' +
          '</g>' +
        '</svg>' +
      '</div>' +
      '<div class="dx-graph-legend">' +
        '<div class="dx-leg dx-leg-red"><span class="dx-leg-dot"></span><div><div class="dx-leg-name">Without protocol support</div><div class="dx-leg-sub">Loses to ' + gw + ' lbs by month 4 · climbs to ' + reboundPeak + ' lbs by month 12</div></div></div>' +
        '<div class="dx-leg dx-leg-green"><span class="dx-leg-dot"></span><div><div class="dx-leg-name">With protocol support</div><div class="dx-leg-sub">Reaches ' + gw + ' lbs by month 6 · holds the line through month 12</div></div></div>' +
      '</div>' +
      '<div class="dx-graph-cap">Forecast curve. Individual results vary; modeled on Lancet eClinicalMedicine (Mar 2026) post-cessation regain data.</div>' +
    '</div>';
  }

  /* ============== RESULTS VIEW ============== */
  function viewResults() {
    var profile     = computeProfile(state.answers);
    var triggers    = computeTriggers(state.answers);
    var testimonials = getTestimonials();
    var timeline    = getTimeline();
    var stage       = state.resultStage;

    /* Computed values used across stages. */
    var cw          = Number(state.answers.current_weight) || 0;
    var gw          = Number(state.answers.goal_weight)    || 0;
    var toGo        = Math.max(0, cw - gw);
    var totalScore  = (profile.scores.R || 0) + (profile.scores.M || 0) + (profile.scores.B || 0);
    var probabilityAll = Math.max(62, Math.min(89, 60 + Math.round(totalScore * 0.9)));
    var protectedProb  = Math.min(14, Math.max(9, Math.round(probabilityAll * 0.14)));

    /* ---- Progress bar (hidden on offer/checkout stage) ---- */
    var progressHtml = (stage < RESULT_STAGE_COUNT) ? buildResultsProgressHtml(stage) : '';

    /* ---- Stage content ---- */
    var stageHtml = '';

    /* ------ STAGE 1: Summary ------ */
    if (stage === 1) {
      var medMap  = { ozempic: 'Ozempic', wegovy: 'Wegovy', mounjaro: 'Mounjaro', zepbound: 'Zepbound', compounded: 'Compounded', off: 'Off the shot' };
      var lostMap = { '<15': 'Under 15', '15-30': '15\u201330', '30-50': '30\u201350', '50+': 'Over 50' };
      var offMap  = { 'taper-now': 'Tapering off now', soon: 'Weighing your off-ramp', staying: 'On the shot for now', undecided: 'Weighing your off-ramp', 'already-off': 'Already off the shot' };
      var offRampLabel = state.answers.glp1 === 'off' ? 'Holding the loss off-shot' : (offMap[state.answers.stop_plan] || 'Weighing your off-ramp');
      var sumCards = [
        { v: lostMap[state.answers.lost] || '\u2014', u: 'lbs', l: 'Lost so far' },
        { v: toGo ? String(toGo) : '\u2014',          u: 'lbs', l: 'Left to your goal' },
        { v: cw  ? String(cw)   : '\u2014',           u: 'lbs', l: 'Current weight' },
        { v: gw  ? String(gw)   : '\u2014',           u: 'lbs', l: 'Goal weight' },
        { v: state.answers.food_noise ? String(state.answers.food_noise) : '\u2014', u: '/ 5', l: 'Food noise level' },
        { v: medMap[state.answers.glp1] || '\u2014', u: '', l: offRampLabel },
      ];
      var sumGridHtml = '<div class="sum-grid">' + sumCards.map(function (c) {
        return '<div class="sum-card"><div class="sum-v">' + esc(c.v) + (c.u ? '<span class="sum-u"> ' + esc(c.u) + '</span>' : '') + '</div><div class="sum-l">' + esc(c.l) + '</div></div>';
      }).join('') + '</div>';

      /* Gauge identical to existing buildGaugeHtml but driven by probabilityAll. */
      var gaugeStroke = (probabilityAll / 100 * 251.3).toFixed(1);
      var gaugeHtml = '<div class="dx-gauge-wrap" id="sec-gauge">' +
        '<div class="dx-gauge-eyebrow">REBOUND PROBABILITY · WITHOUT PROTOCOL SUPPORT</div>' +
        '<div class="dx-gauge">' +
          '<svg viewBox="0 0 200 120" class="dx-gauge-svg" aria-hidden="true">' +
            '<path d="M20 110 A 80 80 0 0 1 180 110" fill="none" stroke="#EFE6D6" stroke-width="14" stroke-linecap="round"/>' +
            '<path d="M20 110 A 80 80 0 0 1 180 110" fill="none" stroke="url(#gaugeGrad2)" stroke-width="14" stroke-linecap="round" stroke-dasharray="' + gaugeStroke + ' 251.3" class="dx-gauge-fill"/>' +
            '<defs><linearGradient id="gaugeGrad2" x1="0" x2="1" y1="0" y2="0"><stop offset="0%" stop-color="#E8B14A"/><stop offset="60%" stop-color="#C74827"/><stop offset="100%" stop-color="#9B2A12"/></linearGradient></defs>' +
          '</svg>' +
          '<div class="dx-gauge-readout"><div class="dx-gauge-num">' + probabilityAll + '<span>%</span></div><div class="dx-gauge-lbl">probability of rebound</div></div>' +
        '</div>' +
        '<div class="dx-gauge-cap">Calculated from your quiz answers, modeled on the Lancet 75.3% rebound benchmark (Mar 2026).</div>' +
      '</div>';

      stageHtml = [
        '<div class="section" id="sec-summary-lead" style="padding-bottom:0">',
        '  <div class="section-eyebrow">Your personal summary</div>',
        '  <h2>Your Rebound Risk is ' + probabilityAll + '%<em>...</em></h2>',
        '  <p class="summary-lead-sub">That means almost 9 in 10 women with your profile gain all the weight back and <strong>MORE</strong> within 12 months of stopping the shot.</p>',
        '</div>',
        gaugeHtml,
        '<div class="section" id="sec-summary">',
        '  <p class="section-intro">The data behind that number, pulled straight from your answers.</p>',
        sumGridHtml,
        '</div>',
        buildStageNavHtml('See My Rebound Profile... And How To Keep It Off', stage),
        buildStageStickyCtaHtml('See My Rebound Profile... And How To Keep It Off'),
      ].join('');
    }

    /* ------ STAGE 2: Diagnosis ------ */
    else if (stage === 2) {
      var trig = DX_TRIGGER[profile.key] || DX_TRIGGER.rebound;
      var artHtml = PROFILE_CARD_ART[profile.key] ? imgTag(PROFILE_CARD_ART[profile.key], '') : '';
      var profileCardHtml = '<div class="section" id="sec-profile-cards" style="padding-top:8px;padding-bottom:0">' +
        '<div class="section-eyebrow">Your profile</div>' +
        '<div class="dx-profile-grid is-single">' +
          '<div class="dx-profile-card is-match">' +
            '<div class="dx-profile-art" aria-hidden="true">' + artHtml + '</div>' +
            '<div class="dx-profile-text">' +
              '<div class="dx-profile-name">' + esc(profile.name) + '</div>' +
              '<div class="dx-profile-why">' + esc(profile.subtitle) + '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

      var dxRootBulletsHtml = DX_ROOT.bullets.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('');
      var trigBulletsHtml   = trig.bullets.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('');
      var rootArtImg = DX_ROOT.art ? '<img src="' + esc(DX_ROOT.art) + '" alt="" loading="lazy">' : '';
      var trigArtImg = trig.art   ? '<img src="' + esc(trig.art)    + '" alt="" loading="lazy">' : '';

      var dxRowsHtml =
        '<div class="dx-diagnosis">' +
          '<div class="dx-row dx-row-root">' +
            '<div class="dx-row-label">' + esc(DX_ROOT.label) + '</div>' +
            '<div class="dx-row-head">' +
              '<div class="dx-row-art" aria-hidden="true">' + rootArtImg + '</div>' +
              '<div class="dx-row-name">' + esc(DX_ROOT.name) + '</div>' +
            '</div>' +
            '<div class="dx-row-body">' + esc(DX_ROOT.lead) + '</div>' +
            '<ul class="dx-bullets">' + dxRootBulletsHtml + '</ul>' +
          '</div>' +
          '<div class="dx-connector"><span>' + esc(trig.connector) + '</span></div>' +
          '<div class="dx-row dx-row-dom">' +
            '<div class="dx-row-label">' + esc(trig.label) + '</div>' +
            '<div class="dx-row-head">' +
              '<div class="dx-row-art" aria-hidden="true">' + trigArtImg + '</div>' +
              '<div class="dx-row-name">' + esc(trig.name) + '</div>' +
            '</div>' +
            '<div class="dx-row-body">' + esc(trig.lead) + '</div>' +
            '<ul class="dx-bullets">' + trigBulletsHtml + '</ul>' +
          '</div>' +
        '</div>';

      var statlineHtml = '<div class="dx-statline">' +
        '<div class="dx-statline-big">75.3% of the weight lost comes back within 52 weeks of stopping the shot... for women who don\'t address Gut Bacterial Burnout.</div>' +
        '<div class="dx-statline-src">Lancet eClinicalMedicine · March 2026</div>' +
      '</div>';

      stageHtml = [
        '<div class="section" id="sec-verdict" style="padding-bottom:0">',
        '  <div class="section-eyebrow">Your diagnosis</div>',
        "  <h2>You're standing at the <em>rebound cliff.</em> Here's what's pulling you over.</h2>",
        '</div>',
        '<div class="results-hero results-hero-dx" id="sec-top">',
        '  <div style="position:relative;z-index:2">',
        '    <div class="profile-badge">● YOUR PROFILE</div>',
        '    <h1 class="profile-name">' + esc(profile.name) + '</h1>',
        '    <p class="profile-sub">' + esc(profile.subtitle) + '</p>',
        buildPersonalBulletsHtml(profile),
        '  </div>',
        '</div>',
        '<div class="section" id="sec-profile-box" style="padding-top:4px;padding-bottom:0">',
        '  <div class="dx-profilebox">Based on your answers, your satiety bacteria have about 60 to 90 days before they collapse. When they go, the food noise (the constant background thinking about food and snacks) comes back. All at once. Like a switch flipping.</div>',
        '</div>',
        profileCardHtml,
        dxRowsHtml,
        statlineHtml,
        '<div class="dx-thesis">Right now, the shot is keeping you chemically thin. The job of your protocol is to make you biologically thin... so the loss holds when the shot stops.</div>',
        '<div class="dx-pricing">The shot costs around $975 a month to stay on. Provitalean is $1.63 a day so you don\'t have to stay on it forever.</div>',
        buildStageNavHtml("Show me what's in it", stage),
        buildStageStickyCtaHtml("Show me what's in it"),
      ].join('');
    }

    /* ------ STAGE 3: Protocol (Meet Provitalean + comparison table) ------ */
    else if (stage === 3) {
      var cmpRows = [
        ['The hunger off-switch keeps working when you taper', 'Food noise floods back the moment the dose drops'],
        ['The loss holds past 52 weeks', 'Three of every four pounds come back within a year'],
        ['AMPK reactivated to target the belly the shot misses', 'Belly fat stays locked in place'],
        ['Lean mass protected, so the loss is fat, not muscle', 'Muscle burned off alongside the fat'],
        ['$1.63 a day, one time, yours to keep', '$975 a month, only while you keep paying'],
      ];
      var cmpHtml = '<div class="cmp-table" id="sec-incomplete-complete">' +
        '<div class="cmp-eyebrow">The incomplete protocol vs the complete one</div>' +
        '<div class="cmp-row cmp-head"><div class="cmp-cell cmp-head-good">With Provitalean</div><div class="cmp-cell cmp-head-bad">The shot alone</div></div>' +
        cmpRows.map(function (row) {
          return '<div class="cmp-row"><div class="cmp-cell cmp-good"><span class="cmp-ic cmp-ic-good" aria-hidden="true">✓</span><span>' + esc(row[0]) + '</span></div><div class="cmp-cell cmp-bad"><span class="cmp-ic cmp-ic-bad" aria-hidden="true">✕</span><span>' + esc(row[1]) + '</span></div></div>';
        }).join('') +
        '<div class="cmp-foot">Same shot. Two outcomes. One supports the bacteria you need so the loss stays gone.</div>' +
      '</div>';

      stageHtml = [
        '<div class="section" id="sec-meet" style="background:var(--cream)">',
        '  <div class="meet-hero">',
        '    <div class="section-eyebrow">Introducing</div>',
        '    <h2 class="meet-h">Rejuveen <em>Provitalean</em>... the gut + metabolic protocol built for women on the shot.</h2>',
        '    <div class="meet-bottle-wrap">' + imgTag(IMG.bottle_solo, 'Rejuveen Provitalean bottle', { class: 'meet-bottle-hero' }) + '</div>',
        '    <p class="section-intro meet-intro">The shot is a miracle. Prescribing it without gut support is an incomplete protocol. Provitalean is the multi-pathway gut + metabolic formula built for women on the shot. Six clinical ingredients. Five biological breakdowns addressed. One capsule a day.</p>',
        '  </div>',
        '  <div class="meet-benefits">',
        '    <div class="benefit-row"><div class="benefit-num">01</div><div class="benefit-body"><div class="benefit-name">Rebuilds the bacteria the shot starves</div><div class="benefit-why">B. lactis B420™ and L. lactis LI-23 help rebuild Akkermansia naturally, the keystone bacteria that produces your body\'s natural satiety signal... the off-switch the shot has been mimicking.</div></div></div>',
        '    <div class="benefit-row"><div class="benefit-num">02</div><div class="benefit-body"><div class="benefit-name">Restores your body\'s natural hunger off-switch</div><div class="benefit-why">L. rhamnosus GG is the first strain depleted by chronic shot use. Restoring it brings your body\'s own appetite regulation back online.</div></div></div>',
        '    <div class="benefit-row"><div class="benefit-num">03</div><div class="benefit-body"><div class="benefit-name">Targets the belly fat the shot doesn\'t touch</div><div class="benefit-why">Morosil® Red Orange supported a 2.5 cm waist reduction in 12 weeks (clinical) by reactivating AMPK, the body\'s fat-burning master switch.</div></div></div>',
        '    <div class="benefit-row"><div class="benefit-num">04</div><div class="benefit-body"><div class="benefit-name">Kills the 3pm sugar crash</div><div class="benefit-why">Chromium at 571% DV may help reduce carb cravings and the late-afternoon spike-crash that pulls you toward sugar.</div></div></div>',
        '    <div class="benefit-row"><div class="benefit-num">05</div><div class="benefit-body"><div class="benefit-name">Safe to stack with your weekly injection</div><div class="benefit-why">Zero known interactions with weekly injection protocols. Take it on the shot for steadier results. Take it after the shot to safeguard them.</div></div></div>',
        '  </div>',
        cmpHtml,
        '  <div class="expert-quote">',
        '    <div class="expert-stars">★★★★★</div>',
        '    <div class="expert-body">' + imgTag(IMG.pro_kathryn, 'Kathryn J. Shattler, MS, RDN', { class: 'expert-img' }) +
        '      <div class="expert-text"><p>"Provitalean may speed weight loss and protect lean muscle while shifting metabolism toward fat-burning."</p><div class="expert-name">Kathryn J. Shattler</div><div class="expert-title">MS, RDN · Registered Dietitian</div></div>',
        '    </div>',
        '  </div>',
        '</div>',
        buildStageNavHtml('Show me the ingredients', stage),
        buildStageStickyCtaHtml('Show me the ingredients'),
      ].join('');
    }

    /* ------ STAGE 4: Ingredients ------ */
    else if (stage === 4) {
      var ALL_INGREDIENTS = {
        morosil:   { key: 'morosil',   img: IMG.ig_morosil,   name: 'Morosil® Moro Red Orange',   sub: 'Morosil · for the waist the shot won\'t shrink',           dose: '400 mg per day · standardized extract', claim: 'Supported a 2.5 cm waist circumference reduction and 5% abdominal-fat reduction in 12 weeks (Cardile et al., 2015).', why: 'Helps reactivate AMPK (your fat-burning master switch) and may target visceral abdominal fat. The ingredient your abdomen is missing.', benefits: ['May support a smaller waist measurement', 'Targets visceral abdominal fat', 'Helps reactivate the fat-burning switch'] },
        chromium:  { key: 'chromium',  img: IMG.ig_chromium,  name: 'Chromium Picolinate',         sub: 'Chromium · for the 3pm sugar crash',                       dose: '200 mcg per day · 571% DV',             claim: '21 published human studies. Anton 2008 significantly reduced carbohydrate and fat cravings; supports healthy blood-sugar response.', why: 'Helps reduce the late-afternoon sugar crash that pulls you toward processed carbs.', benefits: ['May help reduce carb cravings', 'Supports steadier energy', 'Supports stable post-meal blood sugar'] },
        hibiscus:  { key: 'hibiscus',  img: IMG.ig_hibiscus,  name: 'Hibiscus Sabdariffa Extract', sub: 'Hibiscus · for the post-meal bloat',                        dose: '400 mg per day',                        claim: 'Chang 2014, 12-week trial: supported reductions in body weight, body fat, and waist-to-hip ratio.', why: 'May support healthy carb metabolism so your gut bacteria have a calmer environment to recolonize in.', benefits: ['Less post-meal bloat', 'Supports cardiometabolic health', 'Gentle, plant-based fat support'] },
        b420:      { key: 'b420',      img: IMG.ig_b420,      name: 'B. lactis B420™ Probiotic',   sub: 'B. lactis B420 · for the body fat the scale isn\'t showing', dose: '10 billion CFU per day',                claim: 'Up to 4% body-fat reduction in a 6-month, double-blind, placebo-controlled trial (Stenman et al., EBioMedicine 2016, n=225).', why: 'The most-studied "satiety strain" for women on the shot. Helps rebuild Akkermansia naturally and supports lean-mass retention during weight loss.', benefits: ['Less bloating, smoother digestion', 'Supports lean-mass retention', 'Helps rebuild Akkermansia naturally'] },
        rhamnosus: { key: 'rhamnosus', img: IMG.ig_rhamnosus, name: 'L. rhamnosus GG',             sub: 'L. rhamnosus GG · for the cravings that won\'t quit',       dose: '5 billion CFU per day',                 claim: 'The most clinically studied probiotic strain in the world. Sanchez 2014 (24-week): women lost 5.2 kg vs. 3.6 kg placebo... roughly 2× the loss.', why: 'Supports the gut\'s natural appetite regulation. Works on the shot. Helps hold the line when you taper off.', benefits: ['Supports a quieter appetite signal', 'Less afternoon snacking', 'Steady mood + cravings'] },
        lactis:    { key: 'lactis',    img: IMG.ig_lactis,    name: 'L. lactis LI-23',             sub: 'L. lactis LI-23 · for the gut barrier the shot weakens',    dose: '5 billion CFU per day',                 claim: 'Co-cultured satiety strain that supports Akkermansia colonization and short-chain fatty-acid production.', why: 'Pairs with B420 to help rebuild the keystone bacteria the shot depleted. Synbiotic effect = faster recolonization.', benefits: ['Supports Akkermansia rebuild', 'Better short-chain fatty acids', 'Supports a healthier gut barrier'] },
      };
      var igTargeted  = [ALL_INGREDIENTS.morosil, ALL_INGREDIENTS.chromium, ALL_INGREDIENTS.hibiscus];
      var igProbiotic = [ALL_INGREDIENTS.b420, ALL_INGREDIENTS.rhamnosus, ALL_INGREDIENTS.lactis];

      var renderIgTile = function (ig, isSupport) {
        var isPrimary = profile.primaryIngredients.indexOf(ig.key) !== -1;
        var tileClass = 'ingredient-tile' + (isSupport ? ' ig-support' : '') + (isPrimary ? ' is-primary' : '');
        var headClass = 'ig-head' + (isSupport ? ' ig-head-support' : '');
        var bodyHtml = isSupport
          ? '<details class="ig-more"><summary class="ig-more-summary"><span class="ig-more-label">More details</span><span class="ig-more-arrow" aria-hidden="true">↓</span></summary><div class="ig-body"><div class="ig-claim">' + esc(ig.claim) + '</div><div class="ig-why">' + esc(ig.why) + '</div><ul class="ig-benefits">' + ig.benefits.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('') + '</ul></div></details>'
          : '<div class="ig-body"><div class="ig-claim">' + esc(ig.claim) + '</div><div class="ig-why">' + esc(ig.why) + '</div><ul class="ig-benefits">' + ig.benefits.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('') + '</ul></div>';
        return '<div class="' + tileClass + '">' +
          '<div class="ig-sub">' + esc(ig.sub) + '</div>' +
          '<div class="' + headClass + '">' +
            '<div class="ig-img-real">' + imgTag(ig.img, ig.name) + '</div>' +
            '<div class="ig-head-meta"><div class="ig-name">' + esc(ig.name) + '</div>' + (isPrimary ? '<span class="ig-pill">For you</span>' : '') + '<div class="ig-dose">' + esc(ig.dose) + '</div></div>' +
          '</div>' +
          bodyHtml +
        '</div>';
      };

      stageHtml = [
        '<div class="section" id="sec-ingredients" style="background:#fff;border-top:1px solid var(--line);border-bottom:1px solid var(--line)">',
        '  <div class="section-eyebrow">Your personalized 90-day protocol</div>',
        '  <h2>The ingredients <em>built for you.</em></h2>',
        '  <div class="ig-group-label ig-group-you">The targeted three</div>',
        '  <div style="margin-top:8px">' + igTargeted.map(function (ig) { return renderIgTile(ig, false); }).join('') + '</div>',
        '  <div class="ig-group-label ig-group-rest">Supporting ingredients</div>',
        '  <div style="margin-top:8px">' + igProbiotic.map(function (ig) { return renderIgTile(ig, true); }).join('') + '</div>',
        '  <div style="text-align:center;margin-top:16px"><img src="' + esc(IMG.supp_facts) + '" alt="Provitalean Supplement Facts" style="max-width:100%;border-radius:8px;border:1px solid var(--line)" loading="lazy"></div>',
        '</div>',
        buildStageNavHtml('Show me the reviews', stage),
        buildStageStickyCtaHtml('Show me the reviews'),
      ].join('');
    }

    /* ------ STAGE 5: Reviews (press logos + testimonials) ------ */
    else if (stage === 5) {
      var reviewsHtml = testimonials.map(function (t) {
        return '<div class="review-card">' +
          '<div class="review-headline"><span class="review-headline-mark">"</span>' + esc(t.headline) + '<span class="review-headline-mark">"</span></div>' +
          '<div class="review-row">' +
          '<img src="' + esc(t.img) + '" alt="' + esc(t.name) + '" loading="lazy">' +
          '<div class="review-body"><div class="stars">★★★★★</div>' +
          '<p>"' + esc(t.quote) + '"</p>' +
          '<div class="who-meta"><div class="name">' + esc(t.name) + '</div><div class="detail review-badge">' + esc(t.badge || t.detail) + '</div></div>' +
          '</div></div></div>';
      }).join('');

      var pressHtml4 = (IMG.press_vogue || IMG.press_womens_health || IMG.press_forbes) ? (
        '<div class="press-strip">' +
        '<div class="press-strip-label">As seen in</div>' +
        '<div class="press-logos">' +
          (IMG.press_vogue         ? '<img class="press-logo press-logo-vogue"   src="' + esc(IMG.press_vogue)         + '" alt="Vogue" loading="lazy">' : '') +
          (IMG.press_womens_health ? '<img class="press-logo press-logo-wh"      src="' + esc(IMG.press_womens_health) + '" alt="Women\'s Health" loading="lazy">' : '') +
          (IMG.press_forbes        ? '<img class="press-logo press-logo-forbes"  src="' + esc(IMG.press_forbes)        + '" alt="Forbes" loading="lazy">' : '') +
        '</div>' +
        '</div>'
      ) : '';

      stageHtml = [
        pressHtml4,
        '<div class="section">',
        '  <div class="section-eyebrow">Trusted by women on the shot</div>',
        '  <h2>Reviews from women on <em>your protocol.</em></h2>',
        '  <div class="review-grid">' + reviewsHtml + '</div>',
        '</div>',
        buildStageNavHtml('Show me my plan', stage),
        buildStageStickyCtaHtml('Show me my plan'),
      ].join('');
    }

    /* ------ STAGE 6: Plan (risk table, DX graph, timeline) ------ */
    else if (stage === 6) {
      var timeline5 = getTimeline();
      var timelineHtml = timeline5.map(function (t) {
        return '<div class="timeline-item">' +
          '<div class="tl-node" aria-hidden="true">' + t.icon + '</div>' +
          '<div class="tl-content"><div class="week">' + esc(t.week) + '</div><div class="phase">' + esc(t.phase) + '</div><div class="detail">' + esc(t.detail) + '</div></div>' +
        '</div>';
      }).join('');

      stageHtml = [
        '<div class="section" id="sec-plan-head" style="padding-bottom:0">',
        '  <div class="section-eyebrow">Your plan</div>',
        '  <h2>Your protocol, built to <em>hold the loss.</em></h2>',
        '</div>',
        '<div class="plan-risk-head">What your ' + probabilityAll + '% score actually means</div>',
        '<div class="plan-risk">',
        '  <div class="plan-risk-col plan-risk-bad">',
        '    <div class="plan-risk-num">' + probabilityAll + '%</div>',
        '    <div class="plan-risk-lbl">Regain risk · no protocol</div>',
        '    <div class="plan-risk-say"><strong>' + Math.round(probabilityAll / 10) + ' in 10 women</strong> with your profile gain everything back by month 12.</div>',
        '  </div>',
        '  <div class="plan-risk-arrow" aria-hidden="true">→</div>',
        '  <div class="plan-risk-col plan-risk-good">',
        '    <div class="plan-risk-num">' + (100 - protectedProb) + '%</div>',
        '    <div class="plan-risk-lbl">Hold it · with protocol</div>',
        '    <div class="plan-risk-say">With Provitalean, <strong>' + Math.round((100 - protectedProb) / 10) + ' in 10 women</strong> KEEP the weight off through the same window.</div>',
        '  </div>',
        '</div>',
        '<div class="plan-risk-src">Modeled from your quiz answers against Lancet eClinicalMedicine post-cessation regain data, March 2026.</div>',
        '<div class="plan-forecast-lead">Here\'s what your next 12 months can look like...</div>',
        buildDxGraphHtml(cw, gw, probabilityAll),
        '<div class="section" id="sec-timeline">',
        '  <div class="section-eyebrow">What to expect</div>',
        '  <h2>Your <em>first 90 days</em> on the protocol.</h2>',
        '  <p class="section-intro">Most women feel the food noise quiet before the scale moves. Here\'s the typical arc.</p>',
        '  <div class="timeline">' + timelineHtml + '</div>',
        '</div>',
        '<div class="plan-anchor">Less than your morning coffee. And $973/month less than staying on the shot.</div>',
        '<div class="plan-closer">Stop renting your body for $975 a month. Start owning it for $1.63 a day.</div>',
        buildStageNavHtml('START MY ORDER', stage),
        buildStageStickyCtaHtml('START MY ORDER'),
      ].join('');
    }

    /* ------ STAGE 7: Offer / Checkout ------ */
    else if (stage === RESULT_STAGE_COUNT) {
      var offerProgressHtml = [1, 2].map(function (n) {
        var active  = state.offerStep >= n;
        var current = state.offerStep === n;
        return '<div class="op-step' + (active ? ' active' : '') + (current ? ' current' : '') + '">' +
          '<span class="op-num">' + (state.offerStep > n ? '✓' : n) + '</span>' +
          '<span class="op-lbl">' + (n === 1 ? 'Select' : 'Review') + '</span>' +
        '</div>';
      }).join('');

      stageHtml = [
        '<div id="offer-anchor" class="offer-wrap">',
        '  <div class="offer-progress">' + offerProgressHtml + '</div>',
        '  <div class="offer-step-content">' + viewOfferStep(state.offerStep) + '</div>',
        '</div>',
        '<div class="trust-section">',
        '  <div class="trust-card">' + imgTag(IMG.money_back, '90-day guarantee') +
        '    <div><div class="trust-t">90-Day Satisfaction Promise</div><div class="trust-d">If Provitalean doesn\'t help quiet the food noise, ease the bloat, and steady your weight, we\'ll refund every penny... even the empty bottles. No auto-billing. You stay in control.</div></div>',
        '  </div>',
        '</div>',
        '<div class="fine">*Results vary. Statistics from published peer-reviewed clinical studies on B. lactis B420™ (Stenman 2016), Morosil® (Cardile 2015), and L. rhamnosus GG. These statements have not been evaluated by the FDA. This product is not intended to diagnose, treat, cure or prevent any disease.</div>',
        '<div style="padding:0 24px 40px;text-align:center"><button class="btn-primary btn-ghost" data-action="restart">Retake the quiz</button></div>',
      ].join('');
    }

    return '<div class="results" data-screen-label="Results">' + progressHtml + stageHtml + '</div>';
  }

  /* ============== OFFER STEP VIEWS ============== */
  function viewOfferStep(step) {
    if (step === 1) return viewOfferStep1();
    return viewOfferStep2();
  }

  function packageByKey(planKey) {
    return PACKAGES.find(function (p) { return p.k === planKey; }) || PACKAGES[0];
  }

  function offerPackExplainerHtml() {
    return '<div class="prefer-explainer">' +
      '<div class="pe-title">Why most women on the shot start here</div>' +
      '<ul>' +
      '<li><span class="pe-tick">✓</span>3 bottles · one full Akkermansia recolonization cycle... no gaps, no restarting</li>' +
      '<li><span class="pe-tick">✓</span>Save $90 + free shipping</li>' +
      '<li><span class="pe-tick">✓</span>Insurance against rebound when you taper or stop</li>' +
      '</ul>' +
      '</div>';
  }

  function offerPackContinueHtml(p) {
    return '<button type="button" class="btn-primary pack-continue-cta" data-action="offer-next">Continue with ' + esc(p.months) + ' <span class="arrow">→</span></button>';
  }

  function updateSelectedOfferPack(planKey) {
    var packs = document.querySelectorAll('#unhunger-quiz-root .offer-packs .offer-pack');
    for (var i = 0; i < packs.length; i++) {
      var pack = packs[i];
      var isSelected = pack.getAttribute('data-plan') === planKey;
      var radio = pack.querySelector('.pack-radio');
      var dot = radio && radio.querySelector('.dot-fill');
      var explainer = pack.querySelector('.prefer-explainer');
      var cta = pack.querySelector('.pack-continue-cta');

      pack.classList.toggle('selected', isSelected);
      pack.setAttribute('aria-pressed', String(isSelected));

      if (radio && isSelected && !dot) radio.innerHTML = '<span class="dot-fill"></span>';
      if (radio && !isSelected && dot) dot.remove();

      if (!isSelected) {
        if (explainer) explainer.remove();
        if (cta) cta.remove();
        continue;
      }

      if (planKey === '90' && !explainer) {
        pack.insertAdjacentHTML('beforeend', offerPackExplainerHtml());
      } else if (planKey !== '90' && explainer) {
        explainer.remove();
      }

      if (cta) cta.remove();
      pack.insertAdjacentHTML('beforeend', offerPackContinueHtml(packageByKey(planKey)));
    }
  }

  function viewOfferStep1() {
    var packsHtml = PACKAGES.map(function (p) {
      var isFeatured = p.k === '90';
      var isStarter = p.k === '30';
      var sel = state.plan === p.k;
      var tagLine = isFeatured
        ? 'Full reset cycle · best off-ramp insurance.'
        : isStarter
          ? '1 bottle. Not recommended for your risk score. Full reset cycle requires 90 days.'
          : 'Halfway protocol. Most quit before they see real change.';
      var freeShip = p.bottles >= 2 ? 'Free shipping' : '+ shipping';

      var html = '<div class="offer-pack' + (sel ? ' selected' : '') + (isFeatured ? ' featured' : '') + (isStarter ? ' starter' : '') + '" data-action="select-plan" data-plan="' + esc(p.k) + '" role="button" tabindex="0" aria-pressed="' + (sel ? 'true' : 'false') + '">';
      if (p.badge) html += '<div class="pack-badge">' + esc(p.badge) + '</div>';
      if (p.save > 0) html += '<div class="pack-savings">SAVE $' + p.save + '</div>';
      html += '<div class="pack-main">';
      html += '<div class="pack-img">' + imgTag(p.bundle, p.months) + '</div>';
      html += '<div class="pack-meta">';
      html += '<div class="pack-months">' + esc(p.months) + ' · ' + p.bottles + ' ' + (p.bottles === 1 ? 'bottle' : 'bottles') + '</div>';
      html += '<div class="pack-per">' + esc(p.per) + '<span class="pack-per-unit"> /serving</span></div>';
      html += '<div class="pack-price-row"><span class="pack-total">$' + p.total + ' total</span>';
      if (p.strike > p.total) html += '<span class="pack-strike">$' + p.strike + '</span>';
      html += '<span class="pack-save">' + freeShip + '</span></div>';
      html += '</div>';
      html += '<div class="pack-radio">' + (sel ? '<span class="dot-fill"></span>' : '') + '</div>';
      html += '</div>';
      if (p.bottles >= 2 || isStarter) {
        html += '<div class="pack-extra10"><span class="px10-pill">+ EXTRA $10 OFF</span><span class="px10-text">auto-applied at checkout</span></div>';
      }
      html += '<div class="pack-warn">' + esc(tagLine) + '</div>';
      if (isFeatured && sel) {
        html += offerPackExplainerHtml();
      }
      if (sel) {
        html += offerPackContinueHtml(p);
      }
      html += '</div>';
      return html;
    }).join('');

    return [
      '<div class="offer-step" data-screen-label="Offer · Step 1">',
      '  <div class="offer-header">',
      '    <div class="offer-step-badge">STEP 1 OF 2 · SELECT YOUR SUPPLY</div>',
      '    <h2 class="offer-h">Our recommendation for <em>achieving your goals</em></h2>',
      '    <p class="offer-sub">It takes 60–90 days for the missing bacteria to rebuild and the hunger switch to settle for good. Three bottles is the full protocol... not a discount play, a biology one. $1.63/day. No auto-billing.</p>',
      '  </div>',

      '  <div class="why90">',
      '    <div class="why90-title">WHY 90 DAYS IS THE PROTOCOL</div>',
      '    <div class="why90-row">',
      '      <div class="why90-step"><div class="why90-num">14</div><div class="why90-label">Food noise quiets</div><div class="why90-sub">First spark · less snacking, smoother digestion.</div></div>',
      '      <div class="why90-arrow">→</div>',
      '      <div class="why90-step"><div class="why90-num">30</div><div class="why90-label">Cravings drop, bloat eases</div><div class="why90-sub">Real relief · clothes start fitting looser.</div></div>',
      '      <div class="why90-arrow">→</div>',
      '      <div class="why90-step highlight"><div class="why90-num">90</div><div class="why90-label">Lasting control</div><div class="why90-sub">Body holds the progress · rebound risk way down.</div></div>',
      '    </div>',
      '  </div>',

      '  <div class="offer-packs">' + packsHtml + '</div>',
      '  <div class="offer-foot">SSL secured checkout · 256-bit encryption</div>',
      '</div>',
    ].join('');
  }

  function viewOfferStep2() {
    var p = PACKAGES.find(function (x) { return x.k === state.plan; });
    return [
      '<div class="offer-step" data-screen-label="Offer · Step 2">',
      '  <div class="offer-header">',
      '    <div class="offer-step-badge">STEP 2 OF 2 · REVIEW YOUR ORDER</div>',
      '    <h2 class="offer-h">Your personalized <em>Provitalean protocol</em></h2>',
      '  </div>',
      '  <div class="order-card">',
      '    <div class="order-top">',
      '      <div class="order-img">' + imgTag(p.bundle, p.months) + '</div>',
      '      <div class="order-info"><div class="order-name">Provitalean™</div><div class="order-months">' + esc(p.months) + ' · ' + p.bottles + ' ' + (p.bottles === 1 ? 'bottle' : 'bottles') + '</div><div class="order-per">' + esc(p.per) + ' per serving</div></div>',
      '      <div class="order-price"><div class="op-total">$' + p.total + '</div>' + (p.strike > p.total ? '<div class="op-strike">$' + p.strike + '</div>' : '') + '</div>',
      '    </div>',
      '    <div class="order-line"></div>',
      '    <div class="order-rows">',
      '      <div class="or"><span>Subtotal</span><span>$' + p.strike + '.00</span></div>',
      (p.save > 0 ? '<div class="or"><span>Your savings</span><span style="color:var(--orange)">−$' + p.save + '.00</span></div>' : ''),
      (p.bottles >= 2 ? '<div class="or"><span>Extra $10 off (auto-applied)</span><span style="color:var(--orange)">−$10.00</span></div>' : ''),
      '      <div class="or"><span>Shipping</span><span>' + (p.bottles >= 2 ? 'FREE' : '$4.95') + '</span></div>',
      '      <div class="or total"><span>Total</span><span>$' + p.total + '.00</span></div>',
      '    </div>',
      '  </div>',
      '  <div class="order-includes">',
      '    <div class="oi-title">Included with your order:</div>',
      '    <div class="oi-row"><img src="' + esc(IMG.money_back) + '" alt="" loading="lazy"><div>90-day money-back guarantee</div></div>',
      '    <div class="oi-row"><span class="oi-icon">✦</span><div>Free access to our shot off-ramp playbook (digital)</div></div>',
      '    <div class="oi-row"><span class="oi-icon">⚡</span><div>Priority customer support from our wellness team</div></div>',
      '  </div>',
      '  <button class="btn-primary" data-action="checkout">Continue to checkout <span class="arrow">→</span></button>',
      '  <button class="btn-text" data-action="offer-back">← Change my plan</button>',
      '</div>',
    ].join('');
  }

  /* ============== RENDER ============== */
  function questionsSeenBeforeHere() {
    var count = 0;
    for (var i = 0; i < state.step; i++) {
      if (STEPS[i].type === 'q') count++;
    }
    return count;
  }

  function render() {
    var root = getRoot();
    if (!root) return;
    /* Snap forward if a back-step + answer change left us on a now-skipIf'd
       step (e.g. user backs up, switches glp1 to 'off', and current step is
       the now-skipped duration question). */
    ensureStepVisible();
    var cur = STEPS[state.step];
    var inner;
    if (cur.type === 'intro') inner = viewIntro();
    else if (cur.type === 'q') inner = viewQuestion(QUESTIONS[cur.idx]);
    else if (cur.type === 'edu1') inner = viewEduStat(EDUCATION.stat1, questionsSeenBeforeHere() - 1, QUESTIONS.length);
    else if (cur.type === 'edu2') inner = viewEduTriggers(EDUCATION.stat2, questionsSeenBeforeHere() - 1, QUESTIONS.length);
    else if (cur.type === 'edu3') inner = viewEduStat(EDUCATION.stat3, questionsSeenBeforeHere() - 1, QUESTIONS.length);
    else if (cur.type === 'midbreak') inner = viewMidBreak();
    else if (cur.type === 'analyze') inner = viewAnalyzing();
    else if (cur.type === 'results') inner = viewResults();

    var isResults = cur.type === 'results';
    var isIntro = cur.type === 'intro';
    var logo = (CFG.images && CFG.images.logo) || '';
    var ribbon = isIntro ? '' :
      '<div class="brand-ribbon">' +
      (logo ? '<img src="' + esc(logo) + '" alt="Rejuveen">' : '<span style="color:#fff;font-family:var(--serif);font-style:italic;font-size:18px">rejuveen</span>') +
      '</div>';

    root.innerHTML = '<div class="phone-frame' + (isResults ? ' scroll' : '') + '">' + ribbon + inner + '</div>';

    afterRender(cur);
    persistState();
    scrollToTop();
  }

  /* ============== POST-RENDER WIRING ============== */
  function afterRender(cur) {
    animateProgressBar();
    if (cur.type === 'intro') wireIntro();
    else if (cur.type === 'edu1' || cur.type === 'edu3') wireEduStat();
    else if (cur.type === 'edu2') wireEduTriggers();
    else if (cur.type === 'analyze') wireAnalyzing();
    else if (cur.type === 'results') wireResults();
  }

  /* Animate the progress fill from its previous value (data-progress-from)
     to the new target (data-progress-target) so transitions between steps
     pick up where the bar left off instead of restarting at 0%. We use the
     Web Animations API where available (bypasses any CSS transition the
     host theme might have stripped or overridden) and fall back to a
     setTimeout + inline width set that nudges the CSS transition. */
  function animateProgressBar() {
    var fill = document.querySelector('#unhunger-quiz-root .progress-fill[data-progress-target]');
    if (!fill) return;
    var from = fill.getAttribute('data-progress-from') || '0%';
    var target = fill.getAttribute('data-progress-target');
    if (typeof fill.animate === 'function') {
      fill.animate(
        [{ width: from }, { width: target }],
        { duration: 520, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' }
      );
      fill.style.width = target;
    } else {
      fill.style.width = from;
      void fill.offsetWidth;
      setTimeout(function () { fill.style.width = target; }, 20);
    }
    var pct = parseFloat(target);
    if (!isNaN(pct)) lastProgress = pct;
  }

  /* Intro sticky-CTA wiring. Listens on both window (mobile, full-height
     phone-frame) and the .phone-frame scroller (desktop, where the frame
     has its own internal scroll). Previous listener is removed via the
     globally-stashed handler so back/forward nav doesn't accumulate them. */
  function wireIntro() {
    var sticky = document.querySelector('#unhunger-quiz-root .sticky-cta');
    if (!sticky) return;
    var frame = document.querySelector('.phone-frame');
    var onScroll = function () {
      var scrolled = window.scrollY > 120 || (frame && frame.scrollTop > 120);
      if (scrolled) sticky.removeAttribute('hidden');
      else sticky.setAttribute('hidden', '');
    };
    if (window.__unhungerScrollHandler) {
      window.removeEventListener('scroll', window.__unhungerScrollHandler);
      if (window.__unhungerScrollFrame) window.__unhungerScrollFrame.removeEventListener('scroll', window.__unhungerScrollHandler);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (frame) frame.addEventListener('scroll', onScroll, { passive: true });
    window.__unhungerScrollHandler = onScroll;
    window.__unhungerScrollFrame = frame;
    onScroll();
  }

  function wireEduStat() {
    var hero = document.querySelector('#unhunger-quiz-root [data-count-target]');
    if (!hero) return;
    var target = parseFloat(hero.getAttribute('data-count-target'));
    var t0 = null;
    var dur = 1600;
    var raf;
    function tick(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      var v = target * (1 - Math.pow(1 - p, 3));
      var formatted = v.toFixed(1).replace('.0', '');
      hero.firstChild.nodeValue = formatted;
      if (p < 1) raf = requestAnimationFrame(tick);
    }
    hero.firstChild.nodeValue = '0';
    raf = requestAnimationFrame(tick);
  }

  /* Staged-reveal of the rebound-cascade cards. Cards start invisible
     (`opacity:0; transform:translateY(14px)` via CSS); we flip in
     `.is-revealed` one at a time at 420ms intervals to match the new export.
     Continue stays disabled until the full set is revealed. */
  function wireEduTriggers() {
    /* Target both icon items and legacy trigger cards via shared attribute. */
    var items   = document.querySelectorAll('#unhunger-quiz-root [data-edu-reveal]');
    var nextBtn = document.querySelector('#unhunger-quiz-root .quiz-footer .btn-primary');
    if (!items.length) {
      if (nextBtn) nextBtn.removeAttribute('disabled');
      return;
    }
    var idx = 0;
    function reveal() {
      if (idx < items.length) {
        var el = items[idx];
        el.style.opacity    = '1';
        el.style.transform  = 'translateY(0) scale(1)';
        el.classList.add('is-revealed');
        idx++;
        setTimeout(reveal, 420);
      } else if (nextBtn) {
        nextBtn.removeAttribute('disabled');
      }
    }
    setTimeout(reveal, 200);
  }


  function wireAnalyzing() {
    var ANALYZE_STEPS = [
      'Analyzing your responses',
      'Comparing against 12,400 program outcomes',
      'Matching you with the right protocol',
      'Calibrating your 90-day projection',
      'Preparing your case file',
    ];
    var STEP_MS = 2400;
    var total   = STEP_MS * ANALYZE_STEPS.length;
    var t0      = performance.now();
    var raf;

    /* Review carousel */
    var revEls = document.querySelectorAll('#unhunger-quiz-root .analyze-review');
    var dotEls = document.querySelectorAll('#unhunger-quiz-root .arv-dot');
    var revIdx = 0;
    var revInterval = setInterval(function () {
      if (!document.querySelector('#unhunger-quiz-root .analyze-review')) {
        clearInterval(revInterval);
        return;
      }
      var next = revIdx + 1;
      if (next >= revEls.length) return;
      revEls[revIdx].classList.remove('is-active');
      revEls[revIdx].setAttribute('aria-hidden', 'true');
      if (dotEls[revIdx]) dotEls[revIdx].classList.remove('active');
      revIdx = next;
      revEls[revIdx].classList.add('is-active');
      revEls[revIdx].setAttribute('aria-hidden', 'false');
      if (dotEls[revIdx]) dotEls[revIdx].classList.add('active');
    }, 4000);

    var metaEl = document.getElementById('an-meta');
    var textEl = document.getElementById('an-text');
    var fillEl = document.getElementById('an-fill');
    var pipEls = document.querySelectorAll('#unhunger-quiz-root .analyze-pip');
    var lastStep = -1;

    function tick(t) {
      var elapsed = t - t0;
      var overall = Math.min(1, elapsed / total);
      var idx     = Math.min(ANALYZE_STEPS.length - 1, Math.floor(elapsed / STEP_MS));
      var within  = Math.min(1, (elapsed - idx * STEP_MS) / STEP_MS);

      if (fillEl) fillEl.style.width = Math.round(within * 100) + '%';

      if (idx !== lastStep) {
        lastStep = idx;
        if (metaEl) metaEl.textContent = 'Step ' + (idx + 1) + ' of ' + ANALYZE_STEPS.length;
        if (textEl) {
          textEl.innerHTML = esc(ANALYZE_STEPS[idx]) + '<span class="analyze-dots" aria-hidden="true"><span></span><span></span><span></span></span>';
          /* restart CSS animation */
          textEl.style.animation = 'none';
          void textEl.offsetWidth;
          textEl.style.animation = '';
        }
        pipEls.forEach(function (p, i) {
          p.className = 'analyze-pip' + (i < idx ? ' done' : i === idx ? ' active' : '');
        });
      }

      if (overall < 1) {
        raf = requestAnimationFrame(tick);
      } else {
        clearInterval(revInterval);
        setTimeout(function () { gotoNext(); render(); }, 450);
      }
    }
    raf = requestAnimationFrame(tick);
  }

  var quizCompleteFired = false;
  function wireResults() {
    if (!quizCompleteFired) {
      quizCompleteFired = true;
      var profile = computeProfile(state.answers);
      track('QuizComplete', {
        content_name: profile.name,
        glp1_medication: state.answers.glp1,
        glp1_duration: state.answers.duration,
        stop_plan: state.answers.stop_plan,
        goal: state.answers.goal,
      });
    }

    /* Wire DX graph IntersectionObserver for animation. */
    var graphEl = document.getElementById('sec-graph');
    if (graphEl) {
      if (typeof IntersectionObserver !== 'undefined') {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              graphEl.classList.add('is-animating');
              io.disconnect();
            }
          });
        }, { threshold: 0.25, rootMargin: '0px 0px -10% 0px' });
        io.observe(graphEl);
      } else {
        graphEl.classList.add('is-animating');
      }
    }

    /* Stage sticky CTA — shows when scrolled 1.2× viewport and the
       results-continue button is off-screen. Hidden on the offer stage. */
    var stickyEl = document.getElementById('stage-sticky-cta');
    if (!stickyEl || state.resultStage >= RESULT_STAGE_COUNT) return;

    var frame = document.querySelector('#unhunger-quiz-root .phone-frame');
    var target = frame || window;

    var stickyHandler = function () {
      var vh = (frame ? frame.clientHeight : window.innerHeight) || 800;
      var sc = frame ? frame.scrollTop : (window.scrollY || 0);
      var viewportTop    = frame ? frame.getBoundingClientRect().top    : 0;
      var viewportBottom = frame ? frame.getBoundingClientRect().bottom : window.innerHeight;
      var navBtn  = document.querySelector('#unhunger-quiz-root .results-continue');
      var navRect = navBtn && navBtn.getBoundingClientRect();
      var navVisible = navRect ? (navRect.top < viewportBottom - 40 && navRect.bottom > viewportTop + 40) : false;
      var shouldShow = sc > vh * 1.2 && !navVisible;
      if (stickyEl) stickyEl.style.display = shouldShow ? '' : 'none';
    };

    if (window.__unhungerStickyHandler) {
      var prevTarget = window.__unhungerStickyTarget || window;
      prevTarget.removeEventListener('scroll', window.__unhungerStickyHandler);
    }
    target.addEventListener('scroll', stickyHandler, { passive: true });
    window.__unhungerStickyHandler = stickyHandler;
    window.__unhungerStickyTarget  = target;
    stickyHandler();
  }

  /* ============== EVENT DELEGATION ============== */
  function onClick(e) {
    var card = e.target.closest('[data-trigger-card]');
    var target = e.target.closest('[data-action]');
    if (card && (!target || !target.contains(card))) {
      var idx = parseInt(card.getAttribute('data-trigger-card'), 10);
      var nowFlipped = card.classList.contains('is-flipped');
      document.querySelectorAll('#unhunger-quiz-root .trigger-card.is-flipped').forEach(function (c) {
        if (c !== card) {
          c.classList.remove('is-flipped');
          c.setAttribute('aria-pressed', 'false');
        }
      });
      card.classList.toggle('is-flipped', !nowFlipped);
      card.setAttribute('aria-pressed', String(!nowFlipped));
      return;
    }
    if (!target) return;
    var action = target.getAttribute('data-action');

    /* Intro Q1 pick: stores glp1 (mirrors apply via setAnswer when value='off')
       and walks into the branched flow. The standalone glp1 step was removed
       from STEPS so the next step is duration (or time_off, depending on
       which branch the answer just opened). */
    if (action === 'answer-intro-glp1') {
      var iv = target.getAttribute('data-value');
      track('QuizStart', { content_name: 'provitalean_unhunger_quiz' });
      setAnswer('glp1', iv);
      target.classList.add('selected');
      setTimeout(function () {
        gotoNext();
        render();
      }, 240);
      return;
    }

    /* Sticky CTA on the intro screen scrolls back up to the medication
       options so the user can pick one without thumb-walking up the page. */
    if (action === 'scroll-to-intro-options') {
      var first = document.querySelector('#unhunger-quiz-root .iq1-options .iq1-option');
      if (first && first.scrollIntoView) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    if (action === 'next') {
      gotoNext();
      render();
      return;
    }

    if (action === 'back') {
      gotoBack();
      render();
      return;
    }

    if (action === 'restart') {
      state.answers = {};
      state.step = 0;
      state.plan = '90';
      state.offerStep = 1;
      quizCompleteFired = false;
      lastProgress = 0;
      persistState();
      render();
      return;
    }

    if (action === 'answer-radio') {
      var v = target.getAttribute('data-value');
      var qNow = QUESTIONS[STEPS[state.step].idx];
      setAnswer(qNow.id, v);
      document.querySelectorAll('#unhunger-quiz-root .options .option').forEach(function (o) {
        o.classList.remove('selected');
        var ck = o.querySelector('.check');
        if (ck) ck.textContent = '';
      });
      target.classList.add('selected');
      var ckTarget = target.querySelector('.check');
      if (ckTarget) ckTarget.textContent = '✓';
      setTimeout(function () {
        gotoNext();
        render();
      }, 320);
      return;
    }

    if (action === 'answer-severity') {
      var sv = parseInt(target.getAttribute('data-value'), 10);
      var qNow2 = QUESTIONS[STEPS[state.step].idx];
      setAnswer(qNow2.id, sv);
      document.querySelectorAll('#unhunger-quiz-root .severity-cell').forEach(function (o) { o.classList.remove('selected'); });
      target.classList.add('selected');
      setTimeout(function () {
        gotoNext();
        render();
      }, 360);
      return;
    }

    if (action === 'answer-pills') {
      var pv = target.getAttribute('data-value');
      var qNow3 = QUESTIONS[STEPS[state.step].idx];
      setAnswer(qNow3.id, pv);
      document.querySelectorAll('#unhunger-quiz-root .pill').forEach(function (o) { o.classList.remove('selected'); });
      target.classList.add('selected');
      setTimeout(function () {
        gotoNext();
        render();
      }, 320);
      return;
    }

    if (action === 'answer-chip') {
      var cv = target.getAttribute('data-value');
      var qNow4 = QUESTIONS[STEPS[state.step].idx];
      var arr = (state.answers[qNow4.id] || []).slice();
      var on = arr.indexOf(cv) !== -1;
      var nextArr;
      /* "Prefer not to answer" / "None of these" is exclusive — picking it
         clears all others; picking any other option clears it. */
      if (cv === 'nothing') {
        nextArr = on ? [] : ['nothing'];
      } else {
        if (on) nextArr = arr.filter(function (x) { return x !== cv; });
        else nextArr = arr.filter(function (x) { return x !== 'nothing'; }).concat([cv]);
      }
      setAnswer(qNow4.id, nextArr);
      var selected = state.answers[qNow4.id] || [];
      document.querySelectorAll('#unhunger-quiz-root .chips .chip').forEach(function (c) {
        var v2 = c.getAttribute('data-value');
        var isOn = selected.indexOf(v2) !== -1;
        c.classList.toggle('selected', isOn);
        var x = c.querySelector('.x');
        if (isOn && !x) c.insertAdjacentHTML('beforeend', ' <span class="x">✓</span>');
        else if (!isOn && x) x.remove();
      });
      var continueBtn = document.querySelector('#unhunger-quiz-root .quiz-footer .btn-primary');
      var hint = document.querySelector('#unhunger-quiz-root .quiz-footer .footer-hint');
      var canContinue = selected.length > 0;
      if (continueBtn) {
        if (canContinue) continueBtn.removeAttribute('disabled');
        else continueBtn.setAttribute('disabled', '');
      }
      if (hint) hint.style.display = canContinue ? 'none' : '';
      return;
    }

    if (action === 'answer-yesno') {
      var yv = target.getAttribute('data-value');
      var qNowY = QUESTIONS[STEPS[state.step].idx];
      setAnswer(qNowY.id, yv);
      document.querySelectorAll('#unhunger-quiz-root .yesno-cell').forEach(function (o) { o.classList.remove('selected'); });
      target.classList.add('selected');
      setTimeout(function () {
        gotoNext();
        render();
      }, 320);
      return;
    }

    if (action === 'select-plan') {
      var planKey = target.getAttribute('data-plan');
      if (state.plan !== planKey) {
        state.plan = planKey;
        persistState();
        updateSelectedOfferPack(planKey);
      }
      return;
    }

    if (action === 'result-next') {
      e.preventDefault();
      if (state.resultStage < RESULT_STAGE_COUNT) {
        state.resultStage++;
        persistState();
        render();
        setTimeout(function () { scrollToTop(); }, 30);
      }
      return;
    }

    if (action === 'result-back') {
      e.preventDefault();
      if (state.resultStage > 1) {
        state.resultStage--;
        persistState();
        render();
        setTimeout(function () { scrollToTop(); }, 30);
      }
      return;
    }

    if (action === 'result-goto-offer') {
      e.preventDefault();
      state.resultStage = RESULT_STAGE_COUNT;
      state.offerStep = 1;
      persistState();
      render();
      setTimeout(function () { scrollToTop(); }, 30);
      return;
    }

    if (action === 'offer-next') {
      e.preventDefault();
      e.stopPropagation();
      state.offerStep = Math.min(state.offerStep + 1, 2);
      updateOfferStep();
      return;
    }

    if (action === 'offer-back') {
      state.offerStep = Math.max(state.offerStep - 1, 1);
      updateOfferStep();
      return;
    }

    if (action === 'scroll') {
      scrollToId(target.getAttribute('data-target'));
      return;
    }

    if (action === 'checkout') {
      runCheckout();
      return;
    }
  }

  /* Number-input handler. Bound at the document level so it survives every
     re-render. Listens for `input` (typing) on number fields tagged with
     data-action=answer-number; persists the parsed integer (or null when
     cleared) and toggles the Continue button so the user can submit. */
  function onInput(e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input[data-action="answer-number"]')) return;
    var cur = STEPS[state.step];
    if (!cur || cur.type !== 'q') return;
    var q = QUESTIONS[cur.idx];
    if (!q || q.kind !== 'number') return;
    var raw = (t.value || '').trim();
    if (raw === '') {
      delete state.answers[q.id];
    } else {
      var n = parseInt(raw, 10);
      if (isNaN(n)) return;
      state.answers[q.id] = n;
    }
    persistState();
    var val = state.answers[q.id];
    var canContinue = typeof val === 'number' && val >= (q.min || 1) && val <= (q.max || 999);
    var continueBtn = document.querySelector('#unhunger-quiz-root .quiz-footer .btn-primary');
    if (continueBtn) {
      if (canContinue) continueBtn.removeAttribute('disabled');
      else continueBtn.setAttribute('disabled', '');
    }
  }

  /* Enter on a number input advances to the next step when the value is
     valid — saves the user a mouse trip on Q13 / Q15. */
  function onKeydown(e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (!t || !t.matches || !t.matches('input[data-action="answer-number"]')) return;
    var cur = STEPS[state.step];
    if (!cur || cur.type !== 'q') return;
    var q = QUESTIONS[cur.idx];
    if (!q || q.kind !== 'number') return;
    var val = state.answers[q.id];
    var canContinue = typeof val === 'number' && val >= (q.min || 1) && val <= (q.max || 999);
    if (!canContinue) return;
    e.preventDefault();
    gotoNext();
    render();
  }

  function onBlur(e) {
    if (e.target && e.target.matches && e.target.matches('input[name="email"]')) {
      var emailInput = e.target;
      var nameInput = document.querySelector('#unhunger-quiz-root input[name="first_name"]');
      var trimmed = (emailInput.value || '').trim();
      if (!trimmed || trimmed.indexOf('@') === -1) return;

      var profile = computeProfile(state.answers);
      var p = PACKAGES.find(function (x) { return x.k === state.plan; });

      klaviyoIdentify(buildQuizPayload({
        $email: trimmed,
        $first_name: (nameInput && nameInput.value) || undefined,
        quiz_profile: profile && profile.name,
      }));

      if (!hasLeadFired()) {
        markLeadFired();
        track('Lead', {
          content_name: profile && profile.name,
          content_category: 'quiz_email_capture',
          value: p.total,
          currency: 'USD',
        });
      }
    }
  }

  function runCheckout() {
    var profile = computeProfile(state.answers);
    var p = PACKAGES.find(function (x) { return x.k === state.plan; }) || PACKAGES[0];
    var nameInput = document.querySelector('#unhunger-quiz-root input[name="first_name"]');
    var emailInput = document.querySelector('#unhunger-quiz-root input[name="email"]');
    var firstName = nameInput ? nameInput.value : '';
    var email = emailInput ? emailInput.value : '';

    var eventParams = {
      content_ids: [String(p.variantId)],
      content_name: profile.name,
      content_type: 'product',
      contents: [{ id: String(p.variantId), quantity: 1 }],
      currency: 'USD',
      value: p.total,
      num_items: 1,
    };

    track('AddToCart', eventParams);
    track('InitiateCheckout', eventParams);

    var quizProps = buildQuizPayload({
      quiz_profile: profile.name,
      first_name: firstName || '',
      email: email || '',
    });

    /* Direct cart permalink flow:
       /cart/variant:1?attributes[...]&discount=CODE.
       Quiz answers ride along as cart attributes and surface on the order in
       Shopify Admin without nested /cart/clear or /cart/add redirects. */
    var cartQuery = '';
    Object.keys(quizProps).forEach(function (key) {
      var val = quizProps[key];
      if (!val) return;
      cartQuery += (cartQuery ? '&' : '?')
        + 'attributes[' + encodeURIComponent(key) + ']=' + encodeURIComponent(val);
    });

    var discountCode = CFG.discountCode || '';
    if (discountCode) {
      cartQuery += (cartQuery ? '&' : '?') + 'discount=' + encodeURIComponent(discountCode);
    }

    var cartItems = encodeURIComponent(p.variantId) + ':1';

    window.location.href = '/cart/' + cartItems + cartQuery;
  }

  /* ============== INIT ============== */
  function init() {
    var root = getRoot();
    if (!root) return;
    document.addEventListener('click', onClick);
    document.addEventListener('blur', onBlur, true);
    document.addEventListener('input', onInput);
    document.addEventListener('keydown', onKeydown);
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
